const _fc_props = {};
_fc_props.ante_meridiem = 'AM';
_fc_props.post_meridiem = 'PM';
_fc_props.retry = 'Mēģināt vēlreiz';
_fc_props.default = 'Noklusējuma';
_fc_props.origin = 'Izcelsme';
_fc_props.day = 'Diena';
_fc_props.loading = 'Ielādēšana';
_fc_props.list = 'Saraksts';
_fc_props.error = 'Kļūda';
_fc_props.save = 'Saglabāt';
_fc_props.delete = 'Dzēst';
_fc_props.message = 'Ziņojums';
_fc_props.logout = 'Izrakstīties';
_fc_props.add = 'Pievienot';
_fc_props.remove = 'Noņemt';
_fc_props.done = 'Pabeigts';
_fc_props.other = 'Citi';
_fc_props.interval = 'Intervāls';
_fc_props.time = 'Laiks';
_fc_props.speed = 'Ātrums';
_fc_props.longitude = 'Garums';
_fc_props.latitude = 'Platums';
_fc_props.x_minutes = '{0} minūte';
_fc_props.errors = 'Kļūdas';
_fc_props.general = 'Vispārīgi';
_fc_props.messages = 'Ziņojumi';
_fc_props.gps_fixes = 'GPS labojumi';
_fc_props.device_id = 'Ierīces ID';
_fc_props.vehicle = 'Transportlīdzeklis';
_fc_props.employee = 'Darbinieks';
_fc_props.version = 'Versija';
_fc_props.statuses = 'Statusi';
_fc_props.edit = 'Rediģēt';
_fc_props.cancel = 'Atcelt';
_fc_props.yes = 'Jā';
_fc_props.none = 'Neviens';
_fc_props.item = 'Prece';
_fc_props.never = 'Nekad';
_fc_props.name = 'Vārds';
_fc_props.average = 'Vidēji';
_fc_props.items = 'Preces';
_fc_props.true = 'Tiesa';
_fc_props.status = 'Statuss';
_fc_props.distance = 'Attālums';
_fc_props.ok = 'Labi';
_fc_props.login = 'Pieteikšanās';
_fc_props.next = 'Nākamais';
_fc_props.info = 'Informācija';
_fc_props.menu = 'Izvēlne';
_fc_props.not_available = 'Nav pieejams';
_fc_props.back = 'Atpakaļ';
_fc_props.refresh = 'Atsvaidzināt';
_fc_props.select = 'Atlasīt';
_fc_props.dispatch = 'Nosūtīšana';
_fc_props.messaging = 'Ziņojumapmaiņa';
_fc_props.plants = 'Augi';
_fc_props.last_plants = 'Pēdējie augi';
_fc_props.vehicle_types = 'Transportlīdzekļu veidi';
_fc_props.employee_types = 'Darbinieku veidi';
_fc_props.employee_groups = 'Darbinieku grupas';
_fc_props.equipment_groups = 'Aprīkojuma grupas';
_fc_props.status_type = 'Statusa veids';
_fc_props.job = 'Darbs';
_fc_props.order = 'Pasūtījums';
_fc_props.ticket = 'Biļetes nr.';
_fc_props.small = 'Mazs';
_fc_props.medium = 'Vidējs';
_fc_props.large = 'Liels';
_fc_props.reports = 'Ziņojumi';
_fc_props.payroll = 'Algu aprēķins';
_fc_props.support = 'Atbalsts';
_fc_props.username = 'Lietotājvārds';
_fc_props.all = 'Visi';
_fc_props.question = 'Jautājums';
_fc_props.select_employee = 'Izvēlieties darbinieku';
_fc_props.phone = 'Tālrunis';
_fc_props.january = 'Janvāris';
_fc_props.february = 'Februāris';
_fc_props.march = 'Marts';
_fc_props.april = 'Aprīlis';
_fc_props.may = 'Maijs';
_fc_props.june = 'Jūnijs';
_fc_props.july = 'Jūlijs';
_fc_props.august = 'Augusts';
_fc_props.september = 'Septembris';
_fc_props.october = 'Oktobris';
_fc_props.november = 'Novembris';
_fc_props.december = 'Decembris';
_fc_props.are_you_sure_you_want_to_delete = 'Vai tiešām vēlaties dzēst?';
_fc_props.unknown = 'Nezināms';
_fc_props.invalid_date_range_report_is_limited_to_x_days = 'Nederīgs datumu diapazons: ziņojums ir ierobežots līdz {0} dienām';
_fc_props.select_all = 'Atlasīt visu';
_fc_props.resolution = 'Izšķirtspēja';
_fc_props.equipment = 'Aprīkojums';
_fc_props.totals = 'Kopsummas';
_fc_props.region = 'Reģions';
_fc_props.no_data = 'Nav datu';
_fc_props.hotspot = 'Karstais punkts';
_fc_props.hotspot_type = 'Karstvietas tips';
_fc_props.datetime = 'Datums/laiks';
_fc_props.address = 'Adrese';
_fc_props.retrieving_address = 'Notiek adreses izgūšana...';
_fc_props.address_not_found = 'Adrese nav atrasta';
_fc_props.active_time = 'Aktīvais laiks';
_fc_props.destination_time = 'Galamērķa laiks';
_fc_props.complete_time = 'Pilns laiks';
_fc_props.status_report = 'Statusa ziņojums';
_fc_props.export_report = 'Eksportēt pārskatu';
_fc_props.download_report = 'Lejupielādēt pārskatu';
_fc_props.view_report = 'Skatīt pārskatu';
_fc_props.duration = 'Ilgums';
_fc_props.min = 'Min';
_fc_props.start_date_time = 'Sākuma datums/laiks';
_fc_props.select_start_date = 'Izvēlieties sākuma datumu';
_fc_props.end_date_time = 'Beigu datums/laiks';
_fc_props.select_end_date = 'Atlasiet beigu datumu';
_fc_props.trip_time = 'Brauciena laiks';
_fc_props.travel_time = 'Ceļojuma laiks';
_fc_props.description = 'Apraksts';
_fc_props.map_controls = 'Kartes vadīklas';
_fc_props.road = 'Ceļš';
_fc_props.aerial = 'Antenas';
_fc_props.hybrid = 'Hibrīds';
_fc_props.trip = 'Ceļojums';
_fc_props.map = 'Karte';
_fc_props.plant = 'Augs';
_fc_props.select_date = 'Izvēlieties datumu';
_fc_props.apply = 'Pieteikties';
_fc_props.save_settings = 'Saglabāt iestatījumus';
_fc_props.false = 'Nepatiess';
_fc_props.delete_confirmation = 'Dzēšanas apstiprinājums';
_fc_props.last_name = 'Uzvārds';
_fc_props.none_selected = 'Nav atlasīts';
_fc_props.start_date = 'Sākuma datums';
_fc_props.group_by = 'Grupēt pēc';
_fc_props.equipment_employee = 'Aprīkojums / Darbinieks';
_fc_props.inactive = 'Neaktīvs';
_fc_props.active = 'Aktīvs';
_fc_props.note_checking_may_affect_performance = 'Piezīme. Pārbaude var ietekmēt veiktspēju.';
_fc_props.show_distancefuel_used = 'Rādīt attālumu/izlietoto degvielu';
_fc_props.mins = 'Minūtes';
_fc_props.threshold_time = 'Sliekšņa laiks';
_fc_props.include_voided_tickets = 'Iekļaut anulētas biļetes';
_fc_props.note_all_times_listed_are_in_minutes = 'Piezīme: Visi norādītie laiki ir minūtēs';
_fc_props.please_select_a_job_order_or_equipment = 'Lūdzu, atlasiet darbu, pasūtījumu, iekārtu, aprīkojumu vai darbinieku';
_fc_props.device = 'Ierīce';
_fc_props.select_equipment = 'Izvēlieties aprīkojumu';
_fc_props.on_enter = 'Ievadot';
_fc_props.on_exit = 'Izejot';
_fc_props.all_equipment_types = 'Visi aprīkojuma veidi';
_fc_props.summary = 'Kopsavilkums';
_fc_props.units = {};
_fc_props.units.liters = 'Litri';
_fc_props.type = 'Tips';
_fc_props.no_data_available = 'Nav pieejamu datu';
_fc_props.menu = {};
_fc_props.menu.reports = {};
_fc_props.menu.reports.title = {};
_fc_props.menu.reports.title.breakdown = 'Sadalījums';
_fc_props.menu.reports.title.distance_and_fuel_by_region = 'Attālums un degviela pa reģioniem';
_fc_props.menu_settings_title_settings = 'Iestatījumi';
_fc_props.menu_settings_title_alerts = 'Brīdinājumi';
_fc_props.menu.settings = {};
_fc_props.menu.settings.title = {};
_fc_props.menu.settings.title.equipment = 'Aprīkojums';
_fc_props.menu_settings_title_hotspots_regions = 'Karstie punkti un reģioni';
_fc_props.days = '{0} diena(-as)';
_fc_props.home = 'Sākums';
_fc_props.find = 'Atrast';
_fc_props.close_this_panel = 'aizvērt šo paneli';
_fc_props.filters = 'Filtri';
_fc_props.start = 'Sākt';
_fc_props.end = 'Beigas';
_fc_props.location_details = 'Atrašanās vietas informācija';
_fc_props.first_name = 'Vārds';
_fc_props.material_per_hour = 'Materiāls stundā';
_fc_props.equipment_pound = 'Aprīkojuma nr.';
_fc_props.equipment_type = 'Aprīkojuma veids';
_fc_props.options = 'Iespējas';
_fc_props.zoom_on_cursor_position = 'Pietuvināt kursora pozīciju';
_fc_props.display_equipment_identifier = 'Attēlot aprīkojuma identifikatoru';
_fc_props.view_equipment = 'Skatīt aprīkojumu';
_fc_props.view_hotspots = 'Skatīt karstos punktus';
_fc_props.view_regions = 'Skatīt reģionus';
_fc_props.use_standard_filters = 'Izmantot standarta filtrus';
_fc_props.home_plant = 'Mājas augs';
_fc_props.last_plant = 'Pēdējais augs';
_fc_props.equip_types = 'Aprīkojuma veidi';
_fc_props.equip_groups = 'Aprīkojuma grupas';
_fc_props.orders = 'Pasūtījumi';
_fc_props.trakitall = 'TrakitALL';
_fc_props.use_equipment_filter = 'Izmantot aprīkojuma filtru';
_fc_props.all_selected = 'Visi atlasītie';
_fc_props.of = 'No';
_fc_props.your_map_session_has_expired = 'Jūsu kartes sesija ir beigusies. Lūdzu, atsvaidziniet lapu.';
_fc_props.equipment_short = 'Aprīkot.';
_fc_props.job_info_for = 'Darba informācija par';
_fc_props.order_info_for = 'Pasūtījuma informācija';
_fc_props.ticket_info_for_vehicle = 'Informācija par biļetēm transportlīdzeklim';
_fc_props.inbox = 'Ienākošie';
_fc_props.outbox = 'Izsūtne';
_fc_props.alerts = 'Brīdinājumi';
_fc_props.critical = 'Kritisks';
_fc_props.important = 'Svarīgi';
_fc_props.informational = 'Informatīvs';
_fc_props.customer = 'Klients';
_fc_props.view_routes = 'Skatīt maršrutus';
_fc_props.hours_size = 'Stundu skaits';
_fc_props.used_count = 'Izmantoto skaits';
_fc_props.last_login = 'Pēdējā pieteikšanās';
_fc_props.last_vehicle = 'Pēdējais transportlīdzeklis';
_fc_props.regions = 'Reģioni';
_fc_props.employee_type = 'Darbinieka tips';
_fc_props.driver = 'Vadītājs';
_fc_props.js_delete = 'Dzēst';
_fc_props.move = 'Pārvietot';
_fc_props.edit_hotspot = 'Rediģēt karsto punktu';
_fc_props.adjust_shape = 'Pielāgot formu';
_fc_props.edit_region = 'Rediģēt reģionu';
_fc_props.enter_a_start_address = 'Lūdzu, ievadiet sākuma adresi';
_fc_props.select_a_start_hotspot = 'Lūdzu, atlasiet sākuma tīklāju';
_fc_props.failed_to_find_start_hotspot = 'Neizdevās atrast sākuma tīklāju.';
_fc_props.invalid_latitudelongitude = 'Nederīgs platums/garums';
_fc_props.enter_an_end_address = 'Lūdzu, ievadiet gala adresi';
_fc_props.select_an_end_hotspot = 'Lūdzu, atlasiet beigu tīklāju';
_fc_props.failed_to_find_end_hotspot = 'Neizdevās atrast beigu tīklāju.';
_fc_props.print = 'Drukāt';
_fc_props.these_directions_are_for_informational_purposes = 'Šie norādījumi ir sniegti tikai informatīviem nolūkiem. To pilnīgums vai precizitāte netiek garantēta. Būvniecības projekti, satiksme vai citi notikumi var izraisīt faktisko apstākļu atšķiršanos no šiem rezultātiem.';
_fc_props.enter_an_address = 'Lūdzu, ievadiet adresi';
_fc_props.select_a_hotspot = 'Lūdzu, atlasiet tīklāju';
_fc_props.failed_to_find_hotspot = 'Neizdevās atrast tīklāju.';
_fc_props.select_a_vehicle = 'Lūdzu, izvēlieties transportlīdzekli';
_fc_props.failed_to_find_vehicle = 'Neizdevās atrast transportlīdzekli.';
_fc_props.failed_to_find_address = 'Neizdevās atrast adresi';
_fc_props.failed_to_find_vehicles = 'Neizdevās atrast transportlīdzekļus meklēšanas kritērijos.';
_fc_props.get_address = 'Iegūt adresi';
_fc_props.results_for = 'Rezultāti vaicājumam';
_fc_props.error_retrieving_results = 'Kļūda, izgūstot rezultātus';
_fc_props.no_results_found = 'Nav atrasts neviens rezultāts';
_fc_props.address_is_required = 'Adrese ir obligāta';
_fc_props.city_is_required = 'Pilsēta ir obligāta';
_fc_props.set_location = 'Iestatīt atrašanās vietu';
_fc_props.set_area_of_interest = 'Iestatiet interešu jomu';
_fc_props.center_map_here = 'Centrēt karti šeit';
_fc_props.zoom_to_street_level = 'Tuvināt ielas līmenim';
_fc_props.set_start = 'Iestatīt sākumu';
_fc_props.set_end = 'Komplekta beigas';
_fc_props.delete_node = 'Dzēst mezglu';
_fc_props.create_a_hotspot = 'Izveidojiet karsto punktu';
_fc_props.create_a_region = 'Izveidot reģionu';
_fc_props.toggle_shapes = 'Pārslēgt formas';
_fc_props.refresh_map = 'Atsvaidzināt karti';
_fc_props.more_options = 'Vairāk opciju';
_fc_props.recenter_map = 'Centrēt karti';
_fc_props.zoom_to_vehicle = 'Tālummaiņa uz transportlīdzekli';
_fc_props.apply_filters = 'Lietot filtrus';
_fc_props.grid_view = 'Režģa skats';
_fc_props.list_view = 'Saraksta skats';
_fc_props.click_to_sort = 'Noklikšķiniet, lai kārtotu';
_fc_props.message_history = 'Ziņojumu vēsture';
_fc_props.equipment_types = 'Aprīkojuma veidi';
_fc_props.send_message = 'Sūtīt ziņojumu';
_fc_props.last_load = 'Pēdējā slodze';
_fc_props.last_load_on = 'Pēdējā ielāde';
_fc_props.manual_logout = 'Manuāla atteikšanās';
_fc_props.manual_login = 'Manuāla pieteikšanās';
_fc_props.no_employees_logged_in = 'Nav pieteicies neviens darbinieks';
_fc_props.select_phone = 'Izvēlieties tālruni';
_fc_props.you_must_select_a_phone = 'Jums jāizvēlas tālrunis, aprīkojums un darbinieks.';
_fc_props.are_you_sure_you_want_to_logout = 'Vai tiešām vēlaties atteikties?';
_fc_props.fix_time = 'Fiksēt laiku';
_fc_props.to_next_fix = 'uz nākamo labojumu';
_fc_props.minutes_to_next_fix = 'Minūtes līdz nākamajam labojumam';
_fc_props.liters = 'Litri';
_fc_props.destination = 'Galamērķis';
_fc_props.return = 'Atgriešanās';
_fc_props.product = 'Produkts';
_fc_props.no_records_found = 'Nav atrasts neviens ieraksts.';
_fc_props.vehicle_type = 'Transportlīdzekļa tips';
_fc_props.view_in_map = 'Skatīt visu kartē';
_fc_props.uploads = 'Augšupielādes';
_fc_props.upload_csv_file = 'Augšupielādēt CSV failu';
_fc_props.permanent = 'Pastāvīgs';
_fc_props.expire_time = 'Derīguma termiņš';
_fc_props.please_select_x_for_tickets_marked_active = 'Lūdzu, atlasiet {0} biļetēm, kas atzīmētas kā AKTĪVAS';
_fc_props.multiple_tickets_marked_active_for_same_x = 'Vairākas biļetes atzīmētas kā AKTĪVAS vienam un tam pašam {0}';
_fc_props.delivery_time = 'Piegādes laiks';
_fc_props.failure_connecting_to_servlet = 'Kļūme, izveidojot savienojumu ar servletu.';
_fc_props.status_time_summary = 'Statusa laika kopsavilkums';
_fc_props.view_in_map_one = 'Skatīt kartē';
_fc_props.question_report = 'Jautājumu pārskats';
_fc_props.end_date = 'Beigu datums';
_fc_props.trailer_number = 'Piekabes numurs';
_fc_props.region_panel = 'Reģiona panelis';
_fc_props.hotspot_panel = 'Karstpunktu panelis';
_fc_props.shape = 'Forma';
_fc_props.circle = 'Aplis';
_fc_props.polygon = 'Daudzstūris';
_fc_props.click_the_map_to_set_the_location = 'Noklikšķiniet uz kartes, lai iestatītu vēlamo atrašanās vietu.';
_fc_props.click_the_map_to_set_the_hotspot_center = 'Noklikšķiniet uz kartes, lai iestatītu karstpunkta centru.';
_fc_props.click_the_map_to_set_the_region_center = 'Noklikšķiniet uz kartes, lai iestatītu reģiona centru.';
_fc_props.click_and_drag_points = 'Noklikšķiniet un velciet punktus, lai rediģētu formu. Noklikšķiniet uz SAGLABĀT, lai saglabātu izmaiņas.';
_fc_props.size = 'Izmērs';
_fc_props.are_you_sure_you_want_to_move_this = 'Vai tiešām vēlaties to pārvietot?';
_fc_props.are_you_sure_you_want_to_delete_this = 'Vai tiešām vēlaties to dzēst?';
_fc_props.please_enter_a_valid_size = 'Lūdzu, ievadiet derīgu izmēru';
_fc_props.failed_to_save = 'Neizdevās saglabāt.';
_fc_props.failed_to_move = 'Neizdevās pārvietoties.';
_fc_props.failed_to_delete = 'Neizdevās dzēst.';
_fc_props.x_hours = '{0} stundas';
_fc_props.hide_hotspots = 'Slēpt karstos punktus';
_fc_props.show_regions = 'Rādīt reģionus';
_fc_props.show_hotspots = 'Rādīt karstos punktus';
_fc_props.hide_regions = 'Slēpt reģionus';
_fc_props.numeric = 'Skaitlisks';
_fc_props.message_type = 'Ziņojuma veids';
_fc_props.text = 'Teksts';
_fc_props.yes_no = 'Jā/Nē';
_fc_props.responses = 'Atbildes';
_fc_props.disabled = 'Invalīdi';
_fc_props.group_name = 'Grupas nosaukums';
_fc_props.start_timer = 'Startēt taimeri';
_fc_props.stop_timer = 'Apturēt taimeri';
_fc_props.are_you_sure_you_want_to_delete_the_x_format = 'Vai tiešām vēlaties dzēst formātu \'{0}\'?';
_fc_props.phone_number = 'Tālruņa numurs';
_fc_props.interface_pound = 'Saskarnes nr.';
_fc_props.field = 'Lauks';
_fc_props.default_label = 'Noklusējuma etiķete';
_fc_props.custom_label = 'Pielāgota etiķete';
_fc_props.you_must_enter_a_label = 'Jums jāievada etiķete.';
_fc_props.enabled = 'Iespējots';
_fc_props.settings = {};
_fc_props.settings.ticket_integration = 'Biļešu integrācija';
_fc_props.settings.geofence_off_open_hotspots = 'Ģeožoga izslēgšana no atvērtajiem karstajiem punktiem';
_fc_props.settings.associate_open_hotspots_wticket = 'Asociētie atvērtie karstie punkti ar biļeti';
_fc_props.settings.allow_geofencing_off_of_open_hotspots_or_only_hotspots_associated_with_drivers_ticket = 'Atļaut ģeogrāfisko norobežošanu no atvērtiem karstajiem punktiem vai tikai tiem karstajiem punktiem, kas saistīti ar vadītāja biļeti';
_fc_props.settings.whether_or_not_to_associate_open_hotspots_with_tickets_when_a_vehicle_enters_them = 'Vai piesaistīt atvērtos karstos punktus biļetēm, kad tajos iebrauc transportlīdzeklis';
_fc_props.settings.void_ticket_without_destination = 'Nederīga biļete bez galamērķa';
_fc_props.settings.if_a_ticket_is_received_while_another_one_is_active_if_the_active_ticket_does = 'Ja biļete tiek saņemta, kamēr cita ir aktīva, un aktīvajai biļetei nav galamērķa, biļete tiks anulēta.';
_fc_props.settings.autocreate_hotspots = 'Automātiski izveidot karstos punktus';
_fc_props.settings.whether_or_not_to_automatically_create_hotspots_from_the_destination = 'Vai automātiski izveidot piekļuves punktus no galamērķa adreses, saņemot biļeti';
_fc_props.settings.autoactivate_ticket_upon_receive = 'Automātiski aktivizēt biļeti pēc saņemšanas';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_true = 'Vai biļete ir aktīva, kad to saņem TrackIt (pēc noklusējuma ir “true”).';
_fc_props.settings.auto_close_active_ticket_upon_receive_minutes = 'Automātiski aizvērt aktīvo biļeti pēc minūšu saņemšanas';
_fc_props.settings.how_long_does_the_current_active_ticket_need_to_have_been_active_before = 'Cik ilgi pašreizējai aktīvajai biļetei ir jābūt aktīvai, pirms tā tiek automātiski aizvērta (noklusējums \'\')';
_fc_props.settings.ticket_max_activate_age_minutes = 'Biļetes maksimālās aktivizēšanas vecuma minūtes';
_fc_props.settings.how_old_in_minutes_can_a_ticket_be_when_activating_it_in_trackit_default_ = 'Cik veca minūtēs var būt biļete, aktivizējot to pakalpojumā TrackIt (noklusējuma vērtība \'\')';
_fc_props.settings.max_hotspot_unused_days = 'Maksimālais neizmantoto tīklāju dienu skaits';
_fc_props.settings.sets_the_max_days_a_hotspot_can_be_unused_and_still_be_revived = 'Nosaka maksimālo dienu skaitu, cik ilgi karstais punkts var tikt neizmantots un joprojām tikt atdzīvināts';
_fc_props.settings.radius_multiplier = 'Rādiusa reizinātājs';
_fc_props.settings.what_to_multiply_the_radius_by_when_a_ticket_is_received_from_the = 'Ar ko reizināt rādiusu, kad no dispečeru sistēmas tiek saņemta biļete?';
_fc_props.settings.ticket_message_date_format = 'Biļetes ziņojuma datuma formāts';
_fc_props.am = 'rīts';
_fc_props.pm = 'pēcpusdienā';
_fc_props.settings.ticket_message = 'Ziņojums par biļeti';
_fc_props.settings.add_ticket_element = 'Pievienot biļetes elementu';
_fc_props.driver_performance = 'Vadītāja veiktspēja';
_fc_props.update_failed_can_not_connect = 'Atjaunināšana neizdevās: Nevar izveidot savienojumu ar servletu.';
_fc_props.company = 'Uzņēmums';
_fc_props.unknown_error = 'Nezināma kļūda';
_fc_props.selected = 'Atlasīts';
_fc_props.web_service = 'Tīmekļa pakalpojums';
_fc_props.error_processing_request = 'Kļūda, apstrādājot pieprasījumu.';
_fc_props.email_address = 'E-pasta adrese';
_fc_props.id = 'ID';
_fc_props.last_used = 'Pēdējo reizi izmantots';
_fc_props.error_invalid_vehiclenum = 'Kļūda Nederīgs transportlīdzekļa numurs';
_fc_props.error_vehicle_is_not_logged_in = 'Kļūda: Transportlīdzeklis nav reģistrēts.';
_fc_props.status_timer = 'Statusa taimeris';
_fc_props.warning = 'Brīdinājums';
_fc_props.users = 'Lietotāji';
_fc_props.you_dont_have_access_to_this_page = 'Jums nav piekļuves šīs lapas skatīšanai. Lūdzu, sazinieties ar sistēmas administratoru, lai iegūtu piekļuvi.';
_fc_props.previous_week = 'Iepriekšējā nedēļa';
_fc_props.status_breakdown = 'Statusa sadalījums';
_fc_props.select_plant_or_employee_group = 'Jums jāizvēlas vai nu rūpnīca, vai darbinieku grupa.';
_fc_props.cannot_select_plant_and_employee_group = 'Nevar atlasīt gan rūpnīcu, gan darbinieku grupu.';
_fc_props.odometer_must_be_a_number = 'Sākuma odometra rādījumam jābūt skaitlim';
_fc_props.ending_odometer_must_be_a_number = 'Beigu odometra rādījumam jābūt skaitlim';
_fc_props.beginning_hour_meter_must_be_a_number = 'Sākuma stundu skaitītājam jābūt skaitlim';
_fc_props.ending_hour_meter_must_be_a_number = 'Beigu stundu skaitītājam jābūt skaitlim';
_fc_props.error_loading_status_change_page = 'Kļūda, ielādējot statusa maiņas lapu.';
_fc_props.x_is_an_invalid_time_format = '{0} ir nepareizs laika formāts, tam jābūt GGGG-MM-DD HH:MM:SS';
_fc_props.x_for_schedule_login = '{0} ieplānotajai pieteikšanās';
_fc_props.x_for_schedule_logout = '{0} ieplānotai atteikšanās';
_fc_props.x_for_actual_login = '{0} faktiskajai pieteikšanās reizei';
_fc_props.x_for_actual_logout = '{0} faktiskai atteikšanai';
_fc_props.by_refreshing_the_time_card_detail = 'Atsvaidzinot laika kartes datus, jūs zaudēsiet visas izmaiņas. Vai turpināt?';
_fc_props.are_you_sure_you_want_to_delete_0 = 'Vai tiešām vēlaties dzēst {0}?';
_fc_props.settings.command_mobile_ticket_url = 'Komandas mobilā pieteikuma URL';
_fc_props.year = 'Gads';
_fc_props.make = 'Izgatavot';
_fc_props.model = 'Modelis';
_fc_props.settings.command_mobile_ticket_password = 'Command Mobile biļetes parole';
_fc_props.settings.command_mobile_ticket_auth_token = 'Command Mobile biļetes autorizācijas žetons';
_fc_props.target = 'Mērķis';
_fc_props.number_of_digits = 'Ciparu skaits';
_fc_props.number_of_integer_digits = 'Veselo skaitļu ciparu skaits';
_fc_props.number_of_fractional_digits = 'Daļskaitļu ciparu skaits';
_fc_props.search = 'Meklēt';
_fc_props.settings.command_mobile_ticket_date_order = 'Command Mobile biļešu datuma secība';
_fc_props.settings.command_mobile_ticket_date_length = 'Command Mobile biļetes datuma garums';
_fc_props.settings.command_mobile_ticket_date_separator = 'Command Mobile biļetes datuma atdalītājs';
_fc_props.settings.command_mobile_ticket_slash = '/ (slīpsvītra)';
_fc_props.settings.command_mobile_ticket_dash = '- (domuzīme)';
_fc_props.settings.command_mobile_ticket_period = '. (punkts)';
_fc_props.settings.command_mobile_ticket_space = '(atstarpe)';
_fc_props.settings.command_mobile_ticket_time_length = 'Command Mobile biļetes laika ilgums';
_fc_props.settings.command_mobile_ticket_time_separator = 'Command Mobile biļešu laika atdalītājs';
_fc_props.settings.command_mobile_ticket_colon = ': (kols)';
_fc_props.settings.command_mobile_ticket_time_format = 'Command Mobile biļetes laika formāts';
_fc_props.settings.command_mobile_ticket_use_interface_number = 'Izmantojiet saskarnes numuru';
_fc_props.language = 'Valoda';
_fc_props.mechanic = 'Mehāniķis';
_fc_props.settings.command_mobile_ticket_poll_interval = 'Aptaujas intervāls (sekundes)';
_fc_props.driving_time = 'Braukšanas laiks';
_fc_props.find_near_plants = 'Atrast augus tuvumā';
_fc_props.please_create_hot_spot_first = 'Lūdzu, vispirms izveidojiet tīklāju';
_fc_props.pump = 'Sūknis';
_fc_props.please_enter_hot_spot_description = 'Lūdzu, ievadiet karstā punkta aprakstu';
_fc_props.please_select_a_hot_spot_type = 'Lūdzu, atlasiet karsto punktu veidu';
_fc_props.settings.command_mobile_ticket_send_driver_email = 'Sūtīt vadītāja e-pastu';
_fc_props.directions_not_found = 'Nederīga {0} adrese. Norādes nav atrastas.';
_fc_props.ws_user = 'Lietotājs';
_fc_props.ws_service = 'Pakalpojums';
_fc_props.ws_method = 'Metode';
_fc_props.ws_params = 'Parametri';
_fc_props.units_kilometers_abbr = 'KM';
_fc_props.units_miles_abbr = 'MI';
_fc_props.origin_and_destination = 'Izcelsmes un galamērķa';
_fc_props.liter_abbr = 'l';
_fc_props.help = 'Palīdzība';
_fc_props.settings.command_mobile_ticket_use_alt_emp_number = 'Android ierīces alternatīvā darbinieka numura izmantošana';
_fc_props.settings.command_mobile_ticket_android_url = 'Android mobilo biļešu URL';
_fc_props.settings.command_mobile_ticket_android_secret = 'Android mobilo biļešu noslēpums';
_fc_props.employee_x_has_no_logout_on_y = 'Darbiniekam {0} nav izrakstīšanās no maiņas, kas sākas {1}.';
_fc_props.phone_number_has_duplicates = 'Tālruņu numuros ir dublēti ieraksti';
_fc_props.ounce = 'Unce';
_fc_props.water_extra = 'Ūdens papildus';
_fc_props.always = 'Vienmēr';
_fc_props.work_types_must_be_unique = 'Darba tipiem jābūt unikāliem';
_fc_props.manufacturer = 'Ražotājs';
_fc_props.need_to_enter_seconds = 'Nepieciešams ievadīt sekundes.';
_fc_props.copy = 'Kopēt';
_fc_props.create_in_existing_required = 'Lai izveidotu viesabonēšanas tīklāju, ir jāatlasa “Izveidot esošajā”.';
_fc_props.break = 'Pārtraukums';
_fc_props.add_export_data_type = 'Pievienot eksportējamo datu tipu';
_fc_props.edit_export_data_type = 'Rediģēt eksportējamo datu tipu';
_fc_props.delete_export_data_type = 'Dzēst eksportējamo datu tipu';
_fc_props.export_data_type = 'Eksportēt datu tipu';
_fc_props.error_updating_export_data_type = 'Kļūda atjauninot eksportējamo datu tipu';
_fc_props.settings.address_key = 'Adreses atslēga';
_fc_props.settings.address_key_hover = 'Adreses atslēgas opcijas';
_fc_props.settings.address_key_options = 'Adreses atslēgas opcijas';
_fc_props.more_filter_options = 'Vairāk filtrēšanas opciju';
_fc_props.unauthorized_mapit_app = 'Šī MapIt versija nav autorizēta, lūdzu, atjauniniet MapIt pēc iespējas ātrāk.';
_fc_props.zello_timeout = 'Sazinoties ar Zello, iestājās taimauts.';
_fc_props.user_agreement_text = 'Piesakoties, jūs piekrītat';
_fc_props.user_agreement = 'lietotāja līgums';
_fc_props.upload = 'Augšupielādēt';
_fc_props.x_mins_left = 'Atlikušas {0} minūtes';
_fc_props.continuous_location_tracking_colon = 'Nepārtraukta atrašanās vietas izsekošana:';
_fc_props.hired_hauler_cannot_register_device = 'Nolīgts pārvadātājs nevar reģistrēt jaunu ierīci.';
_fc_props.timecard_does_not_contain_shift = 'Darbinieka laika kartē nav norādītā maiņa (laika kartes informācija).';
_fc_props.timecard_not_found = 'Darbinieka laika karte nav atrasta';
_fc_props.vehicle_must_be_assigned_for_clt = 'Transportlīdzeklim jābūt piesaistītam trases atrašanās vietai.';
_fc_props.vehicle_unassigned_continuous_tracking_disabled = 'Transportlīdzeklim tika noņemta piešķirtā funkcija; nepārtrauktā izsekošana tiks atspējota.';
_fc_props.units_yards_abbr = 'YD';
_fc_props.units_meters_abbr = 'M';
_fc_props.error_lost_edc_connection = 'Zaudēts savienojums ar telemātikas ierīci. Lūdzu, pārbaudiet, vai ir iespējots Wi-Fi un/vai Bluetooth.';
_fc_props.acknowledge_all = 'Apstiprināt visus';
_fc_props.expand = 'Izvērst';
_fc_props.collapse = 'Sakļaut';
_fc_props.expand_all = 'Izvērst visu';
_fc_props.collapse_all = 'Sakļaut visu';
_fc_props.last_update = 'Pēdējais atjauninājums';
_fc_props.acknowledge_alert = 'Apstiprināt brīdinājumu';
_fc_props.acknowledge_message = 'Apstiprināt ziņojumu';
_fc_props.acknowledge_all_alerts = 'Apstiprināt visus brīdinājumus';
_fc_props.acknowledge_all_messages = 'Apstiprināt visus ziņojumus';
_fc_props.eta = 'AP';
_fc_props.tolerance_must_be_a_valid_integer = 'Pielaidei jābūt derīgam veselam skaitlim no -99 līdz 99 (abus ieskaitot)';
_fc_props.gps_permission_required = 'Nepieciešama GPS atļauja';
_fc_props.permissions_required = 'Nepieciešamās atļaujas';
_fc_props.change_user = 'Mainīt lietotāju';
_fc_props.account_not_registered_with_carrier = 'Šis konts nav reģistrēts pie mobilo sakaru operatora.';
_fc_props.slump_loss = 'Lejupslīdes zaudējumi';
_fc_props.slump_loss_help = 'Palīdzība krīzes laikā';
_fc_props.did_not_receive_any_edc_devices = 'Nesaņēma nevienu ierīci.';
_fc_props.edc_record_not_found = 'Telemātikas ierīces ieraksts netika atrasts';
_fc_props.disable_hotspot_prompt = 'Lūdzu, pieskarieties “Labi”, kad tiek prasīts atspējot tīklāju.';
_fc_props.edc_device_is_in_use = 'Telemātikas ierīce {0} tiek lietota.';
_fc_props.an_unknown_exception_has_occurred = 'Radusies nezināma izņēmuma situācija';
_fc_props.login_has_timed_out = 'Pieteikšanās ir beigusies';
_fc_props.use_paper_logs = 'Izmantojiet papīra žurnālus';
_fc_props.eld_login_failed = 'Pieteikšanās darba laikā neizdevās.';
_fc_props.setup_time_off_type = 'Lūdzu, iestatiet brīvā laika veidu.';
_fc_props.view_load_properties = 'Skatīt ielādes īpašības';
_fc_props.couldnt_download_edc_firmware = 'Nevarēja lejupielādēt telemātikas ierīces programmaparatūru.';
_fc_props.password_incorrect = 'Parole nepareiza';
_fc_props.edc_configuration_password_prompt = 'Šīs ierīces stāvokļa dēļ konfigurēšanai ir jāievada instalētāja parole.';
_fc_props.edc_configuration_check_failed = 'Telemātikas ierīces servera ierakstu validācija neizdevās. Lūdzu, skatiet sīkāku informāciju kļūdu ziņojumos.';
_fc_props.configuration_issues_prompt = 'Konfigurējot atlasīto telemātikas ierīci norādītajai kravas automašīnai, tika konstatētas šādas problēmas.';
_fc_props.checking_password = 'Paroles pārbaude';
_fc_props.reset_password_instructions_sent = 'Norādījumi paroles atiestatīšanai nosūtīti uz e-pasta adresi {0}.';
_fc_props.reset_password_failed = 'Paroles atiestatīšana neizdevās, mēģiniet vēlreiz.';
_fc_props.forgot_password = 'Aizmirsu paroli?';
_fc_props.enter_valid_email = 'Nederīga e-pasta adrese, lūdzu, ievadiet derīgu e-pasta adresi un mēģiniet vēlreiz.';
_fc_props.issues_while_updating_edc_record = 'Telemātikas ierīce tika veiksmīgi konfigurēta. Tomēr pastāv problēmas ar ierīces ierakstiem TrackIt serverī, kas var izraisīt tās darbības traucējumus. Lūdzu, sazinieties ar atbalsta dienestu, lai labotu informāciju.';
_fc_props.sending = 'Sūtīšana...';
_fc_props.minimum_ratio = 'Minimālā attiecība';
_fc_props.vin = 'VIN';
_fc_props.probe_rpm_not_in_range = 'Bungas apgriezieni nav diapazonā';
_fc_props.probe_failure = 'Zondes atteice';
_fc_props.unknown_probe_data_failure = 'Nezināma zondes datu kļūme';
_fc_props.no_loaded_status_meaning = 'Nav ielādes statusa';
_fc_props.no_depart_status_meaning = 'Nav izlidošanas statusa';
_fc_props.no_arrive_status_meaning = 'Nav ierašanās statusa';
_fc_props.no_begin_work_status_meaning = 'Nav uzsākta darba statusa';
_fc_props.no_fully_mixed_status_meaning = 'Nav pilnībā jaukta statusa';
_fc_props.no_begin_work_or_at_job_status = 'Nav norādīti statusi “Sākt darbu” vai “Pieņemts darbā”.';
_fc_props.driver_didnt_follow_procedure = 'Vadītājs neievēroja procedūru (nepalēnināja trumuļa ātrumu)';
_fc_props.probe_malfunction = 'Zondes darbības traucējumi (iekšēja kļūme utt.)';
_fc_props.no_data_from_probe = 'Nav datu no zondes (datu zudums)';
_fc_props.missing_probe_calibration = 'Nav zondes kalibrēšanas datu';
_fc_props.probe_pressure_not_in_range = 'Zondes spiediens nav diapazonā';
_fc_props.arrival = 'Ierašanās';
_fc_props.small_load = 'MAZĀ KRĀVĀ';
_fc_props.dry_slump = 'SAUSAIS GRŪTĪJUMS';
_fc_props.probe_remixing_turns = 'Remiksēšana';
_fc_props.turns_needed_to_remix = 'Pievienots ūdens — nepieciešama papildu sajaukšana';
_fc_props.probe_remixing_finished = 'Remiksēšana pabeigta';
_fc_props.probe_battery_low_alert = 'Zondes akumulatora zema līmeņa brīdinājums';
_fc_props.probe_battery_low_message = 'Zondes akumulatora līmenis ir zems';
_fc_props.probe_battery_low = 'Zondes akumulatora līmenis ir zems';
_fc_props.alert_when_probe_battery_low = 'Brīdinājums, kad zondes akumulatora līmenis ir zems';
_fc_props.probe_sensor_fatal_failure = 'Sensora fatāla kļūme';
_fc_props.probe_thermistor_failure = 'Termistora atteice';
_fc_props.probe_sensor_stuck_in_concrete = 'Sensors iestrēdzis betonā';
_fc_props.probe_sensor_over_weight = 'Sensors pārsniedz svaru';
_fc_props.probe_batteries_low = 'Zems akumulatora līmenis';
_fc_props.no_probe_data = 'Nav zondes datu:';
_fc_props.check_probe = 'Pārbaudiet zondi';
_fc_props.service_probe = 'Pakalpojumu zonde';
_fc_props.below_x = 'Zem {0}';
_fc_props.above_x = 'Virs {0}';
_fc_props.probe_serial_number_invalid_format = 'Zondes sērijas numurs nav derīgā formātā, kā parādīts lauka aizvietotājā.';
_fc_props.talk_dnd_permission_prompt = 'Sarunai nepieciešama atļauja NETRAUCĒT.';
_fc_props.max = 'Makss';
_fc_props.status_changed_quickly = 'Statuss mainījās pārāk ātri';
_fc_props.is_empty = 'Ir tukšs';
_fc_props.slump_increased_plasticizer_question = 'Vai tika pievienots plastifikators?';
_fc_props.slump_increased_water_added_question = 'Cik daudz nemērīta ūdens tika pievienots?';
_fc_props.probe_and_drs_are_not_support_together_on_the_same_device = 'Zondes un piegādes cikla uzraudzība netiek atbalstīta kopā vienā ierīcē.';
_fc_props.no_data_from_sensor = 'Nav datu no sensora (datu zudums)';
_fc_props.dvir = 'DVIR';
_fc_props.system_type = 'Sistēmas tips';
_fc_props.magnet_count = 'Magnētu skaits';
_fc_props.sensors_setup = 'Sensoru iestatīšana';
_fc_props.drs_requires_io_mac_sensor_drum_type_magnet_count = 'DCM nepieciešams iestatīt I/O Box MAC adresi, cilindra veidu, DCM veidu un magnētu skaitu.';
_fc_props.drs = 'DCM';
_fc_props.drs_ticketed_volume = 'Biļešu apjoms';
_fc_props.drs_current_volume = 'Pašreizējais apjoms';
_fc_props.drs_current_water_cement_ratio = 'Pašreizējā ūdens/cementa attiecība';
_fc_props.drs_target_water_cement_ratio = 'Mērķa ūdens/cementa attiecība';
_fc_props.drs_total_revolutions = 'Kopā';
_fc_props.drs_current_volume_lp_small = 'Pašreizējais';
_fc_props.drum_revolutions = 'Bungu apgriezieni';
_fc_props.drs_total_revolutions_lp_small = 'Kopā';
_fc_props.drs_charging_revolutions_lp_small = 'Uzlāde';
_fc_props.drs_discharging_revolutions_lp_small = 'Izlāde';
_fc_props.drs_target_wc_lp_small = 'Mērķa W/C';
_fc_props.drs_current_wc_lp_small = 'Pašreizējais nedēļas nogales laiks';
_fc_props.drs_ticketed_volume_lp_small = 'Biļete apmaksāta';
_fc_props.android_location_disclosure = 'TrackIt izmanto precīzus un aptuvenus atrašanās vietas datus, lai fonā apkopotu atrašanās vietas datus pat tad, kad tie netiek izmantoti, lai nodrošinātu automātisku statusa noteikšanu un kartes redzamību reāllaikā dispečeru vajadzībām.';
_fc_props.android_location_usage = 'Atrašanās vietas atklāšana';
_fc_props.end_pour_trigger_threshold = 'Beigu ieliešanas aktivizēšanas slieksnis';
_fc_props.drs_wiring_error = 'Elektroinstalācijas kļūda';
_fc_props.drs_wiring_pulse_error = 'Elektroinstalācijas impulsa kļūda';
_fc_props.drs_wiring_magnet_error = 'Elektroinstalācijas magnēta kļūda';
_fc_props.drs_magnet_missing_error = 'Kļūda "Trūkst magnēta"';
_fc_props.android_location_disclosure_3p = 'TrackIt fonā apkopo atrašanās vietas datus, lai nodrošinātu automātisku statusa noteikšanu un reāllaika kartes redzamību nosūtīšanai. Kad nosūtītājs ir izrakstījis ziņojumu, atrašanās vieta netiek kopīgota.';
_fc_props.please_select_either_fullmdm_or_trackit_remote_support = 'Lūdzu, izvēlieties vai nu pilnu MDM, vai Trackit attālo atbalstu.';
_fc_props.move_up = 'Pārvietot uz augšu';
_fc_props.move_down = 'Pārvietot uz leju';
_fc_props.driver_not_found = 'Draiveris nav atrasts.';
_fc_props.multiple = 'Vairāki';
_fc_props.water_meter_installed = 'Ūdens skaitītājs uzstādīts';
_fc_props.delete_waypoint = 'Dzēst ceļa punktu';
_fc_props.wash_sensor_installed = 'Mazgāšanas sensors ir uzstādīts';
_fc_props.washing_start_time = 'Mazgāšanas sākuma laiks';
_fc_props.end_washing = 'Beigt mazgāšanu';
_fc_props.variable_rpms = 'Var RPM';
_fc_props.no_slump = 'Nav krituma';
_fc_props.end_washing_duration = 'Beigu mazgāšanas ilgums';
_fc_props.privacy_policy = 'Privātuma politika';
_fc_props.privacy_policy_text = 'Esmu izlasījis(-usi) un piekrītu';
_fc_props.login_fail_accept_privacy_policy = 'Lai turpinātu, ir jāpiekrīt privātuma politikai.';
_fc_props.rotation_sensor = 'Rotācijas sensors';
_fc_props.pto_sensor = 'Jūgvārpstas sensors';
_fc_props.pto_sensor_installed = 'PTO sensors ir uzstādīts';
_fc_props.polarity_reversed = 'Apgrieztā polaritāte';
_fc_props.pto_sensor_type = 'PTO sensora tips';
_fc_props.sensor_type = 'Sensora tips';
_fc_props.prompt_select_pto_sensor_type = 'Ja kā galvenā sensora tipu esat izvēlējies "Jūgvārpstas sensors", jāizvēlas "Jūgvārpstas sensora tips".';
_fc_props.priming_turns_at_full_load = 'Iesūknēšana griežas pie pilnas slodzes';
_fc_props.priming_turns_at_ten_percent_load = 'Iesūknēšana pagriežas pie 10% slodzes';
_fc_props.weight_units = 'Svara vienības';
_fc_props.settings.send_status = 'Nosūtīt statusu/atrašanās vietu uz Event Bridge';
_fc_props.volume_difference = 'Apjoma starpība';
_fc_props.mobile_ticket_iframe_url = 'Mobilās biļetes IFrame URL';
_fc_props.mobile_ticket_user = 'Mobilo biļešu lietotājs';
_fc_props.mobile_ticket_password = 'Mobilās biļetes parole';
_fc_props.current_truck_status = 'Pašreizējais kravas automašīnas statuss';
_fc_props.estimated_symbol = '℮';
_fc_props.almost_equal_to_symbol = '≈';
_fc_props.triggered_by_max_revolutions = 'Iedarbina maksimālās apgriezienu skaita dēļ';
_fc_props.alerts_by_type = 'Brīdinājumi pēc veida';
_fc_props.water_flow_meter = 'Ūdens plūsmas mērītājs';
_fc_props.flow_meter_no_pulses_warning = 'Nav pulsācijas — brīdinājums';
_fc_props.flow_meter_no_pulses_critical = 'Nav impulsu — kritiski svarīgi';
_fc_props.flow_meter_excessive_pulses = 'Pārmērīgi pākšaugi';
_fc_props.flow_meter_constantly_flowing = 'Pastāvīgi plūstošs';
_fc_props.flow_meter_good = 'Labi';
_fc_props.whats_new = 'Kas jauns';
_fc_props.whats_new_widget_text = 'Vai zinājāt, ka mēs atjauninām TrackIt vismaz reizi mēnesī? Saņemiet jaunākos atjauninājumus un padomus.';
_fc_props.get_the_scoop = 'Iegūstiet informāciju';
_fc_props.trackit_insights = 'Trackit Insights';
_fc_props.business_analytics_blurb = 'Biznesa analītika, kas uzlabo jūsu peļņu, tagad iekļauta TrackIt komplektā';
_fc_props.find_out_more = 'Uzziniet vairāk';
_fc_props.daily_breakdown = 'Dienas sadalījums';
_fc_props.question_summary = 'Jautājuma kopsavilkums';
_fc_props.trip_summary = 'Ceļojuma kopsavilkums';
_fc_props.manage_employees = 'Darbinieku pārvaldība';
_fc_props.manage_hotspots = 'Pārvaldīt karstos punktus';
_fc_props.manage_devices = 'Pārvaldīt ierīces';
_fc_props.manage_equipment = 'Pārvaldīt aprīkojumu';
_fc_props.manage_users = 'Pārvaldīt lietotājus';
_fc_props.manage_statuses = 'Pārvaldīt statusus';
_fc_props.manage_alerts = 'Pārvaldīt brīdinājumus';
_fc_props.popular_report_links = 'Populāras ziņojumu saites';
_fc_props.popular_settings_links = 'Populāru iestatījumu saites';
_fc_props.sidemenu_settings = 'Iestatījumi';
_fc_props.loads_per_driver = 'Kravas uz vienu vadītāju';
_fc_props.please_select_application = 'Lūdzu, atlasiet vismaz vienu lietojumprogrammu';
_fc_props.external_app_processing = 'Apstrāde ārējā lietotnē';
_fc_props.external_app_sent = 'Nosūtīts uz ārēju lietotni';
_fc_props.external_app_received = 'Saņemts no ārējās lietotnes';
_fc_props.wait_time_at_job = 'Gaidīšanas laiks darbā';
_fc_props.wait_time_at_plant = 'Gaidīšanas laiks rūpnīcā';
_fc_props.loading_time = 'Iekraušanas laiks';
_fc_props.unloading_time = 'Izkraušanas laiks';
_fc_props.pre_post_trip = 'Pirms/pēc ceļojuma';
_fc_props.update_thresholds = 'Atjaunināšanas sliekšņi';
_fc_props.green = 'Zaļš';
_fc_props.yellow = 'Dzeltens';
_fc_props.red = 'Sarkans';
_fc_props.between = 'Starp';
_fc_props.num_of_loads = 'Kravu skaits';
_fc_props.num_of_drivers = 'Vadītāju skaits';
_fc_props.status_meaning_not_setup = 'Statuss Nozīme nav iestatīts';
_fc_props.or_less = 'Vai mazāk';
_fc_props.or_greater = 'Vai lielāks';
_fc_props.probe_self_diagnostic_state = 'Zondes pašdiagnostikas stāvoklis';
_fc_props.update_current_truck_status_settings = 'Atjaunināt pašreizējās kravas automašīnas statusa iestatījumus';
_fc_props.default_behavior = 'Noklusējuma (10 populārākie statusi)';
_fc_props.combine_similar_statuses = 'Apvienot vienādus statusus no visiem tipiem (cikli)';
_fc_props.use_other_category = 'Izmantojiet kategoriju “Cits”';
_fc_props.selected_statuses = 'Atlasītie statusi';
_fc_props.ideas = 'Idejas';
_fc_props.air_content = 'Gaisa saturs';
_fc_props.air_measured_time = 'Gaisa mērīšanas laiks';
_fc_props.ten_max = '10 Maks';
_fc_props.loads_per_plant = 'Slodzes uz vienu augu';
_fc_props.invalid_flow_meter_pulse_per_volume = 'Nederīgs plūsmas mērītāja impulss uz tilpumu.';
_fc_props.coming_soon_title = 'Drīzumā būs pieejami vēl citi logrīki';
_fc_props.submit_your_ideas = 'Iesniedziet savas idejas mūsu ideju portālā, izmantojot spuldzītes ikonu kreisajā navigācijas izvēlnē.';
_fc_props.selected_plants = 'Atlasītie augi';
_fc_props.update_loads_per_plant_settings = 'Atjaunināt ielādes katram augam iestatījumus';
_fc_props.default_top_10_plants = 'Noklusējums (10 populārākie augi)';
_fc_props.phone_number_will_be_uploaded = 'Reģistrācijas nolūkos tiks augšupielādēts ierīces ID.';
_fc_props.include_deleted = 'Iekļaut dzēstos';
_fc_props.primary_status_type = 'Primārā statusa veids';
_fc_props.additional_status_trigger = 'Papildu statusa aktivizētāji';
_fc_props.update_tickets_destination = 'Atjaunināt galamērķi visās saistītajās biļetēs';
_fc_props.settings.send_destination_changes_to_connex = 'Nosūtīt galamērķa izmaiņas uz Connex';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_always = 'Vai biļete ir aktīva, kad to saņem TrackIt (pēc noklusējuma “vienmēr”).';
_fc_props.settings.autoactivate_next_ticket_on_ticket_completion = 'Automātiski aktivizēt nākamo pieteikumu pēc iepriekšējā pieteikuma pabeigšanas';
_fc_props.settings.should_autoactivate_next_ticket_on_ticket_completion_default_true = 'Pēc pieprasījuma pabeigšanas automātiski jāaktivizē nākamais pieprasījums (noklusējuma vērtība ir “true”)';
_fc_props.settings.status_to_idle_status_when_no_active_ticket = 'Statuss uz dīkstāves statusu, ja nav aktīvas biļetes';
_fc_props.break_down = 'Sadalīt';
_fc_props.idle = 'Dīkstāve';
_fc_props.pto_work_maximum_speed_limit = 'Darba maksimālā ātruma ierobežojums';
_fc_props.settings.associate_ticket_to_status_on_complete = 'Saistītā statusa maiņa, kas pabeidz pieprasījumu ar šo pieprasījumu';
_fc_props.approaching = 'Tuvojas';
_fc_props.performing_task = 'Veicot uzdevumu';
_fc_props.are_you_sure_you_want_to_delete_geogate = 'Vai tiešām vēlaties dzēst Geogate {0}?';
_fc_props.trackit_destination_changed_to_0 = 'Atjaunināt pieteikumu {0}. Galamērķis ir mainīts.';
_fc_props.trackit_return_destination_changed_to_0 = 'Atjaunināt pieprasījumu {0}. Atgriešanas pieprasījums ir mainīts.';
_fc_props.menu_settings_title_geogate = 'Ģeogeita';
_fc_props.add_geogate = 'Pievienot ģeogrāfisko vārtu';
_fc_props.driver_enabled = 'Vadītājs iespējots';
_fc_props.dispatcher_enabled = 'Dispečers ir iespējots';
_fc_props.runsheet_number = 'Skriešanas lapas numurs';
_fc_props.manual_load = 'Manuāla ielāde';
_fc_props.delivery = 'Piegāde';
_fc_props.return_run = 'Atgriešanās skrējiens';
_fc_props.home_run = 'Mājas skrējiens';
_fc_props.edit_geogate = 'Rediģēt ģeogrāfisko vārteju';
_fc_props.handling = 'Apstrāde';
_fc_props.geogate_name = 'Ģeogeita';
_fc_props.geogate_panel = 'Ģeovārtu panelis';
_fc_props.vehicle_is_not_logged_in = 'Ziņojums nav nosūtīts (transportlīdzeklis nav pieteicies)';
_fc_props.air = 'Gaiss';
_fc_props.create_a_geogate = 'Izveidojiet ģeogrāfisko vārtu';
_fc_props.click_the_map_to_set_the_geogate_points = 'Noklikšķiniet uz kartes, lai iestatītu ģeogrāfiskās vārtu punktus.';
_fc_props.clock_out = 'Izslēgšanās';
_fc_props.handling_operation = 'Apstrādes darbība';
_fc_props.view_geogates = 'Skatīt ģeogrāfiskos vārtus';
_fc_props.select_a_geogate = 'Lūdzu, izvēlieties ģeogrāfisko vārtu vietni';
_fc_props.failed_to_find_geogate = 'Neizdevās atrast Geogate.';
_fc_props.adjust_geogate = 'Pielāgot ģeogrāfisko vārtu';
_fc_props.geogate_expiration_date_time_extra_days = 'Ģeogrāfiskās vārtu vārtu derīguma termiņa beigu laiks Noklusējuma papildu dienas';
_fc_props.menu_settings_title_retention = 'Datu saglabāšana';
_fc_props.category = 'Kategorija';
_fc_props.telemetry = 'Telemetrija';
_fc_props.ticket_data = 'Biļešu dati';
_fc_props.driver_break = 'Vadītāja pārtraukums';
_fc_props._30_days = '30 dienas';
_fc_props._6_months = '6 mēneši';
_fc_props._1_year = '1 gads';
_fc_props._3_years = '3 gadi';
_fc_props.discharge = 'Izlāde';
_fc_props.new_group = 'Jauna grupa';
_fc_props.selected_vehicles = 'Atlasītie transportlīdzekļi';
_fc_props.group_name_is_required_field = 'Grupas nosaukuma lauks ir obligāts.';
_fc_props.at_least_vehicle_should_be_selected = 'Jāizvēlas vismaz viens transportlīdzeklis';
_fc_props.groups = 'Grupas';
_fc_props.trucks = 'Kravas automašīnas';
_fc_props.geogate_has_been_removed_please_refresh_page = 'Ģeogrāfiskā vārteja ir noņemta. Lūdzu, atsvaidziniet lapu.';
_fc_props.air_timestamp = 'Gaisa laika zīmogs';
_fc_props.fail = 'NEKĻŪDA';
_fc_props.stuck = 'IESTRĒGTS';
_fc_props.dirty = 'NETĪRS';
_fc_props.driver_breakdown = 'Sadalījums';
_fc_props.seasonal = 'Sezonāls';
_fc_props.category_details = 'Kategorijas informācija';
_fc_props.alert_events = 'Brīdinājuma notikumi';
_fc_props.driver_performance_infractions = 'Vadītāja snieguma pārkāpumi';
_fc_props.telemetry_details = 'Atrašanās vietas dati, karstie punkti, laiks karstajos punktos, laiks reģionos, DCM dati, zondes dati, dzinēja dati';
_fc_props.ticket_data_details = 'Biļešu dati';
_fc_props.general_details = 'Statusa izmaiņas, laika uzskaites kartes, grafiki';
_fc_props.wash = 'Mazgāt';
_fc_props.filter_options = 'Filtra opcijas';
_fc_props.home_plants = 'Mājas augi';
_fc_props.delivery_multidrop = 'Daudzpunktu piegāde';
_fc_props.dcm = 'DCM';
_fc_props.pto_requires_pto_sensor_type_value = 'DCM jūgvārpstai ir nepieciešams iestatīt jūgvārpstas sensora tipu.';
_fc_props.invalid_io_box_mac_address = 'Nederīga I/O Box Mac adrese';
_fc_props.access_denied = 'Piekļuve liegta';
_fc_props.wash_events = 'Mazgāšanas pasākumi';
_fc_props.min_speed = 'Minimālais ātrums';
_fc_props.temperature_change = 'Temperatūras izmaiņas';
_fc_props.degrees_cap = 'Grādi';
_fc_props.washout_tracking = 'Izskalošanas izsekošana';
_fc_props.approaching_wash = 'Tuvojas Wash';
_fc_props.arrival_wash = 'Ierašanās mazgāšanas';
_fc_props.performing_wash = 'Veicot mazgāšanu';
_fc_props.wash_complete = 'Mazgāšana pabeigta';
_fc_props.must_be_positive_or_zero = 'Jābūt pozitīvam vai nullei!';
_fc_props.min_speed_greater_than_max = 'Minimālajam ātrumam jābūt mazākam par maksimālo ātrumu!';
_fc_props.clock_in = 'Ienākšanas reģistrācija';
_fc_props.mix_water_at_x_to_y_for_t = 'Maisiet ūdeni ar ātrumu {0} līdz {1} apgr./min. {2} apgriezienus.';
_fc_props.discharge_water_for_x_revolutions = 'Izlejiet ūdeni {0} apgriezienu laikā.';
_fc_props.eod_drum_wash_complete = 'Tvertnes mazgāšana pabeigta! <br> Apturiet cilindru ar zondi augšpusē.';
_fc_props.washing_complete = 'Vadīta mazgāšana pabeigta';
_fc_props.eod_washout_no_data_available = 'Sensora dati nav pieejami, lūdzu, pabeidziet mazgāšanas procesu.';
_fc_props.eod_washout_no_data_available_title = 'Vadāma izskalošana nav pieejama';
_fc_props.menu_reports_title_ticket_time_summary = 'Biļetes laika kopsavilkums';
_fc_props.menu_reports_description_ticket_time_summary = 'Skatīt pasūtījuma vai transportlīdzekļa biļetes laika informāciju';
_fc_props.menu_reports_title_summary = 'Kopsavilkums';
_fc_props.menu_reports_title_ticket_summary = 'Biļešu kopsavilkums';
_fc_props.menu_reports_description_summary1 = 'Skatīt laika kopsavilkumu karstajos punktos';
_fc_props.menu_dispatch_title_main = 'Galvenais';
_fc_props.menu_dispatch_title_login_registry = 'Pieteikšanās reģistrs';
_fc_props.menu_reports_title_main = 'Galvenais';
_fc_props.time_management_are_you_sure_you_want_to_delete_export_data_type = 'Vai tiešām vēlaties dzēst šo eksportējamo datu tipu?';
_fc_props.dvir_status_paper_logs = 'Papīra žurnāli';
_fc_props.menu_reports_title_billing_report = 'Norēķinu pārskats';
_fc_props.menu_reports_description_billing_report = 'Norēķinu pārskats';
_fc_props.settings_status_to_ticketed_status_on_activate_work = 'Statuss uz biļetēm, aktivizējot darbu';
_fc_props.settings_status_to_ticketed_status_on_activate_work_default_false = 'Statuss uz biļešu statusu, aktivizējot darbu (noklusējuma vērtība ir “False”)';
_fc_props.status_change_type_drum_rotation_sensor = 'DCM';
_fc_props.settings_connex_eid = 'Connex EID';
_fc_props.units_weight_pound_label = 'Mārciņas';
_fc_props.units_weight_kilogram_label = 'Kilogrami';
_fc_props.settings_weight = 'Svars';
_fc_props.units_pounds = 'Mārciņas';
_fc_props.units_kilograms = 'Kilogrami';
_fc_props.geo_gate_edit_modal_description = 'Apraksts';
_fc_props.geo_gate_edit_modal_start_point = 'Sākuma punkts';
_fc_props.geo_gate_edit_modal_end_point = 'Beigu punkts';
_fc_props.geo_gate_edit_modal_vehicle_types = 'Aprīkojuma veids';
_fc_props.geo_gate_edit_modal_heading_south = 'Dienvidi uz ziemeļiem';
_fc_props.geo_gate_edit_modal_heading_north = 'No ziemeļiem uz dienvidiem';
_fc_props.geo_gate_edit_modal_driver_message = 'Vadītāja ziņojums';
_fc_props.geo_gate_edit_modal_dispatcher_message = 'Nosūtīšanas ziņojums';
_fc_props.geo_gate_edit_modal_expiration_date_time = 'Derīguma termiņš Laiks';
_fc_props.geo_gate_edit_modal_permanent = 'Pastāvīgs';
_fc_props.geo_gate_edit_modal_critical = 'Kritisks';
_fc_props.geo_gate_edit_modal_error_message_description_empty = 'Kļūda, saglabājot ģeogrāfisko vārteju: apraksta laukam jābūt aizpildītam.';
_fc_props.geo_gate_edit_modal_error_message_start_point_empty = 'Kļūda, saglabājot ģeogrāfisko vārtu lauku: Sākuma punkta laukam jābūt aizpildītam.';
_fc_props.geo_gate_edit_modal_error_message_start_point_invalid_format = 'Kļūda, saglabājot ģeogrāfisko vārtu izvietojumu: sākuma punkta laukā ir nepareizs datu formāts.';
_fc_props.geo_gate_edit_modal_error_message_end_point_invalid_format = 'Kļūda, saglabājot ģeogrāfisko vārteju: beigu punkta laukā ir nepareizs datu formāts.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_empty = 'Kļūda, saglabājot ģeogrāfisko vārteju: ir jāaizpilda derīguma termiņa beigu datuma laika lauks.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_invalid_format = 'Kļūda, saglabājot ģeogrāfisko vārteju: derīguma termiņa beigu datuma un laika laukā ir nepareizs datu formāts.';
_fc_props.geo_gate_edit_modal_error_message_heading_north_dispatcher_message_empty = 'Kļūda, saglabājot ģeogrāfisko vārteju: ziemeļu–dienvidu virzienā — ir jāaizpilda nosūtīšanas ziņojuma lauks.';
_fc_props.geo_gate_edit_modal_error_message_no_changes = 'Kļūda, saglabājot Geogate: Nav konstatētas izmaiņas.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_expired = 'Kļūda, saglabājot Geogate: Derīguma termiņa beigu datuma un laika laukā ir beidzies derīguma termiņš.';
_fc_props.geo_gate_edit_modal_error_message_description_invalid_format = 'Kļūda, saglabājot ģeogrāfisko vārteju: apraksta laukā drīkst būt tikai burti un cipari.';
_fc_props.geo_gate_edit_modal_error_message_vehicle_types_empty = 'Kļūda, saglabājot Geogate: Ir jāaizpilda lauks “Aprīkojuma veids”.';
_fc_props.geo_gate_table_message_label_north_to_south = 'No ziemeļiem uz dienvidiem';
_fc_props.geo_gate_table_message_label_south_to_north = 'Dienvidi uz ziemeļiem';
_fc_props.geo_gate_table_message_label_both = 'Abi';
_fc_props.geo_gate_edit_modal_field_point_tip = 'Platums, garums';
_fc_props.geo_gate_edit_modal_device_movement_message_restriction = 'Atzīmējot šo opciju, tiks ignorēti ierīces pārvietošanas ziņojumu ierobežojuma iestatījumi.';
_fc_props.geo_gate_edit_modal_seasonal = 'Sezonāls';
_fc_props.geo_gate_edit_modal_error_message_seasonal_empty = 'Kļūda, saglabājot Geogate: Jāaizpilda sezonālie datumi';
_fc_props.geo_gate_edit_modal_error_message_seasonal_invalid_date_format = 'Kļūda, saglabājot Geogate: Sezonālo datumu laukos ir nepareizs datu formāts.';
_fc_props.test_js_test_javascript = 'Testēt Javascript';
_fc_props.units_miles_per_hour_abbr = 'Mph';
_fc_props.units_kilometers_per_hour_abbr = 'Km/h';
_fc_props.units_kilometers = 'Kilometri';
_fc_props.units_miles = 'Jūdzes';
_fc_props.units_gallons_abbr = 'GAL';
_fc_props.units_liters_abbr = 'L';
_fc_props.geo_gate_edit_modal_error_message_heading_south_driver_message_empty = 'Kļūda, saglabājot ģeogrāfisko vārteju: no dienvidiem uz ziemeļiem — jāaizpilda vadītāja ziņojuma lauks.';
_fc_props.geo_gate_edit_modal_error_message_heading_south_dispatcher_message_empty = 'Kļūda, saglabājot ģeogrāfisko vārteju: no dienvidiem uz ziemeļiem — jānosūta ziņojums, un laukam jābūt aizpildītam.';
_fc_props.geo_gate_edit_modal_error_message_heading_north_driver_message_empty = 'Kļūda, saglabājot ģeogrāfisko vārteju: no ziemeļiem uz dienvidiem — Vadītāja ziņojuma lauks ir jāaizpilda.';
_fc_props.geo_gate_heading = 'Virsraksts';
_fc_props.geo_gate_edit_modal_error_message_end_point_empty = 'Kļūda, saglabājot ģeogrāfisko vārteju: jāaizpilda beigu punkta lauks';
_fc_props.units_mile = 'Jūdze';
_fc_props.units_kilometer = 'Kilometrs';
_fc_props.cloud_dvir__exit = 'Izeja';
_fc_props.cloud_dvir__signature = 'Paraksts';
_fc_props.cloud_dvir__inspection = 'Pārbaude';
_fc_props.cloud_dvir__add_photos_notes = 'Pievienot fotoattēlus/piezīmes';
_fc_props.cloud_dvir__odometer_reading = 'Odometra rādījums';
_fc_props.cloud_dvir__engine_hours = 'Dzinēja stundas';
_fc_props.cloud_dvir__truck_details = 'Kravas automašīnas detaļas';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_vehicle = 'Nosakiet transportlīdzekļa vispārējo stāvokli';
_fc_props.cloud_dvir__full_name_and_signature_of_driver = 'Vadītāja pilns vārds un paraksts';
_fc_props.cloud_dvir__sign = 'Zīme';
_fc_props.cloud_dvir__driver_note_from = 'Vadītāja piezīme no';
_fc_props.cloud_dvir__add_notes = 'Pievienot piezīmes';
_fc_props.cloud_dvir__driver_notes = 'Vadītāja piezīmes';
_fc_props.cloud_dvir__done = 'Pabeigts';
_fc_props.cloud_dvir__needs_repair = 'Nepieciešams remonts';
_fc_props.cloud_dvir__not_applicable = 'Nav piemērojams';
_fc_props.cloud_dvir__review_and_sign = 'Pārskatīt un parakstīt';
_fc_props.cloud_dvir__add_photos = 'Pievienot fotoattēlu';
_fc_props.cloud_dvir__upload_photo_limit = 'Varat augšupielādēt līdz 3 attēliem';
_fc_props.cloud_dvir__mismatch_title = 'Neatbilstības brīdinājums';
_fc_props.cloud_dvir__ok = 'Labi';
_fc_props.cloud_dvir_template = 'Mākoņa DVIR veidne';
_fc_props.cloud_dvir__needs_review = 'DVIR vajadzību pārskatīšana';
_fc_props.cloud_dvir__submitted = 'Iesniegts';
_fc_props.cloud_dvir__completed_by = 'Pabeidzis';
_fc_props.cloud_dvir__review_btn = 'RevIew';
_fc_props.cloud_dvir__truck_number = 'Kravas automašīna {0}';
_fc_props.cloud_dvir__pending_review = 'Gaida pārskatīšanu';
_fc_props.cloud_dvir__start_dvir = 'Sākt DVIR';
_fc_props.cloud_dvir__dvir_history = 'DVIR vēsture';
_fc_props.cloud_dvir__view_all = 'Skatīt visu';
_fc_props.load_zone = 'Slodzes zona';
_fc_props.view_load_zones = 'Skatīt slodzes zonas';
_fc_props.edit_load_zone = 'Rediģēt slodzes zonu';
_fc_props.create_a_load_zone = 'Izveidojiet slodzes zonu';
_fc_props.load_zone_panel = 'Slodzes zonas panelis';
_fc_props.click_the_map_to_set_the_load_zone_center = 'Noklikšķiniet uz kartes, lai iestatītu slodzes zonas centru.';
_fc_props.cloud_dvir__mismatch_title_all_items_ok = 'Šajā pārbaudē ir norādīti defekti, un jūs esat izvēlējies, ka šo transportlīdzekli ir droši lietot. Lūdzu, apstipriniet to pirms turpināt.';
_fc_props.cloud_dvir__mismatch_title_needs_repair = 'Šajā pārbaudē nav konstatēti defekti, un jūs esat izvēlējies, ka šis transportlīdzeklis nav drošs lietošanai. Lūdzu, apstipriniet izvēli pirms turpināt.';
_fc_props._90_days = '90 dienas';
_fc_props.cloud_dvir = 'Mākoņa DVIR';
_fc_props.cloud_dvir_details = 'Mākoņa DVIR iesniegumi';
_fc_props.show_load_zones = 'parādīt slodzes zonas';
_fc_props.hide_load_zones = 'slēpt slodzes zonas';
_fc_props.no = 'Nē';
_fc_props.cloud_dvir__reset = 'Atiestatīt';
_fc_props.cloud_dvir__clear = 'Skaidrs';
_fc_props.mark_read = 'Marks Rīds';
_fc_props.mark_unread = 'Atzīmēt kā nelasītu';
_fc_props.read = 'Lasīt';
_fc_props.unread = 'Nelasīts';
_fc_props.air_sensor_serial_number = 'Gaisa sensora sērijas nr.';
_fc_props.air_sensor_mac_address = 'Gaisa sensora MAC adrese';
_fc_props.air_sensor_serial_number_invalid_format = 'Gaisa sensora sērijas numurs nav derīgā formātā: (burtciparu un ne vairāk kā 32 rakstzīmes garš ar domuzīmēm)';
_fc_props.air_sensor_mac_address_invalid_format = 'Gaisa sensora MAC adrese nav derīgā heksadecimālformātā, kā parādīts lauka aizvietotājā.';
_fc_props.air_sensor_license = 'Gaisa sensors';
_fc_props.adjust_route_point = 'Pielāgot maršruta punktu';
_fc_props.route_point_panel = 'Maršruta punktu panelis';
_fc_props.route_point = 'Maršruta punkts';
_fc_props.cloud_dvir__pre_trip = 'Pirms brauciena';
_fc_props.cloud_dvir__post_trip = 'Pēc ceļojuma';
_fc_props.cloud_dvir__other_insction_type = 'Citi';
_fc_props.cloud_dvir__dvir_completed = 'Pabeigts';
_fc_props.cloud_dvir__awaiting_mechanic = 'Gaidošais mehāniķis';
_fc_props.cloud_dvir__awaiting_driver = 'Gaida vadītāja apstiprinājumu';
_fc_props.unable_to_check_air_sensor_serial_number_please_contact_support_for_assistance = 'Nevar pārbaudīt gaisa sensora sērijas numuru. Sazinieties ar atbalsta dienestu, lai saņemtu papildu palīdzību.';
_fc_props.this_air_sensor_serial_number_exists_please_use_another_serial_number = 'Šis gaisa sensora sērijas numurs jau pastāv, lūdzu, izmantojiet citu sērijas numuru.';
_fc_props.unable_to_check_air_sensor_mac_address_please_contact_support_for_assistance = 'Nevar pārbaudīt gaisa sensora MAC adresi. Lūdzu, sazinieties ar atbalsta dienestu, lai saņemtu palīdzību.';
_fc_props.cloud_dvir__error_submit_dvir_title = 'Kļūda, iesniedzot DVIR';
_fc_props.cloud_dvir__error_submit_dvir_descr = 'Lūdzu, mēģiniet vēlreiz';
_fc_props.ticket_integration_descr = 'Biļešu integrācija ļauj iestatīt biļešu integrācijas iestatījumus, kā arī sākuma ekrānu/ielādes ekrānu/cietās montāžas displeju.';
_fc_props.cloud_dvir__success_submit_dvir_title = 'DVIR veiksmīgi iesniegts';
_fc_props.cloud_dvir__inspection_trip_type = 'Pārbaudes brauciena veids';
_fc_props.menu_dvir_title_mechanic = 'Mehāniķis';
_fc_props.sidemenu_dvir = 'DVIR';
_fc_props.air_sensor_firmware = 'Gaisa sensora programmaparatūra';
_fc_props.when_no_active_ticket = 'Ja nav aktīvas biļetes';
_fc_props.used_by = 'Lietots līdz';
_fc_props.fields = 'Lauki';
_fc_props.are_you_sure_you_want_to_delete_ticket_layout = 'Vai tiešām vēlaties dzēst biļešu izkārtojumu "{0}"?';
_fc_props.menu_settings_title_ticket_layout = 'Biļešu izkārtojums';
_fc_props.add_ticket_layout = 'Pievienot biļešu izkārtojumu';
_fc_props.edit_ticket_layout = 'Rediģēt biļešu izkārtojumu';
_fc_props.ticket_layout_edit_modal_name = 'Vārds';
_fc_props.ticket_layout_edit_modal_default = 'Noklusējuma';
_fc_props.ticket_layout_edit_modal_error_message_name_empty = 'Kļūda, saglabājot pieteikuma izkārtojumu: ir jāaizpilda nosaukuma lauks.';
_fc_props.ticket_layout_edit_modal_error_message_name_invalid_format = 'Kļūda, saglabājot biļetes izkārtojumu: Nosaukuma laukā drīkst būt tikai burti un cipari.';
_fc_props.ticket_layout_edit_modal_fields = 'Lauki';
_fc_props.ticket_layout_edit_modal_usage = 'Lietojums';
_fc_props.ticket_layout_has_been_removed_please_refresh_page = 'Biļešu izkārtojums ir noņemts. Lūdzu, atsvaidziniet lapu.';
_fc_props.more_lower_case = 'vairāk';
_fc_props.ticket_layout_edit_modal_error_selected_fields_are_empty = 'Kļūda, saglabājot biļetes izkārtojumu: ir jāatlasa viens vai vairāki lauki.';
_fc_props.ticket_layout_edit_modal_error_selected_statuses_are_empty = 'Kļūda, saglabājot pieteikuma izkārtojumu: jāatlasa viens vai vairāki statusi.';
_fc_props.cloud_dvir__ad_hoc = 'Ad hoc';
_fc_props.radius_multiplier_should_be = 'Rādiusa reizinātājam jābūt peldošam skaitlim';
_fc_props.ticket_max_activate_age_err = 'Biļetes maksimālās aktivizēšanas vecuma minūtēm jābūt veselam skaitlim.';
_fc_props.max_hotspot_unused_days_errs = 'Maksimālajam neizmantoto karsto punktu skaitam (Max Hotspot Unused Days) jābūt veselam skaitlim.';
_fc_props.begin_pour_air_content = 'Sāciet ieliet gaisa saturu';
_fc_props.arrival_air_content = 'Ierašanās gaisa saturs';
_fc_props.fully_mixed_air_content = 'Pilnībā sajaukts gaisa saturs';
_fc_props.departure_air_content = 'Izlidošanas gaisa saturs';
_fc_props.popup_enabled = 'Uznirstošie logi ir iespējoti';
_fc_props.popup_disabled = 'Uznirstošie logi ir atspējoti';
_fc_props.cloud_dvir__leave_confirmation_title = 'Brīdinājums';
_fc_props.cloud_dvir__leave_confirmation_description = 'Izejot no lapas tagad, visas izmaiņas tiks zaudētas.';
_fc_props.cloud_dvir__leave_confirmation_approve = 'Apstiprināt';
_fc_props.cloud_dvir__leave_confirmation_abort = 'Atcelt';
_fc_props.air_bt_ratio = 'Gaisa sensora mērīšana';
_fc_props.cloud_dvir__view_photos_notes = 'Skatīt fotoattēlus/piezīmes';
_fc_props.error_adding_the_status_it_will_create_a_blank_usage_in_another_ticket_layout = 'Pievienojot statusu, citā biļešu izkārtojumā tiks izveidots tukšs lietojums. Vai vēlaties turpināt pievienošanu?';
_fc_props.vehicle_does_not_have_air_sensor_license = 'Transportlīdzeklim nav gaisa sensora licences.';
_fc_props.air_sensor_installed = 'Gaisa sensors ir uzstādīts';
_fc_props.load_card = 'Ielādēt karti';
_fc_props.cloud_dvir__inspection_profile = 'Pārbaudes profils';
_fc_props.cloud_dvir__view_details = 'Skatīt sīkāku informāciju';
_fc_props.cloud_dvir__certify_repairs = 'Sertificēt remontu';
_fc_props.cloud_dvir__repairs_made = 'Veiktie remonti';
_fc_props.cloud_dvir__repairs_not_necessary = 'Remonts nav nepieciešams';
_fc_props.cloud_dvir__mechanic_note_from = 'Mehāniķa piezīme no';
_fc_props.cloud_dvir__mechanic_assignment = 'Mehāniķa uzdevums';
_fc_props.cloud_dvir__mechanic_signature_description = 'Atzīmējiet visus piemērojamos punktus zemāk un parakstiet, apliecinot, ka transportlīdzeklis ir pienācīgi pārbaudīts.';
_fc_props.cloud_dvir__condition_satisfactory_label = 'Šī transportlīdzekļa stāvoklis ir apmierinošs';
_fc_props.cloud_dvir__defects_corrected_label = 'Defekti ir novērsti';
_fc_props.cloud_dvir__repair_not_required_label = 'Remonts nav nepieciešams transportlīdzekļa drošai ekspluatācijai';
_fc_props.safety = 'Drošība';
_fc_props.cloud_dvir__awaiting_sign = 'Gaidīšanas zīme';
_fc_props.cloud_dvir__dvir_review = 'DVIR apskats';
_fc_props.settings.mobile_auto_start_navigation = 'Automātiska navigācijas palaišana mobilajā ierīcē';
_fc_props.cloud_dvir__edit = 'Rediģēt';
_fc_props.delete_custom_label = 'Dzēst pielāgoto etiķeti';
_fc_props.cloud_dvir__error_incompatible_aux_version = 'Jūsu TrackIt versija ir novecojusi, un dažas DVIR funkcijas var nedarboties pareizi. Pirms turpināt, lūdzu, atjauniniet TrackIt.';
_fc_props.cloud_dvir__error_submit_dvir_signature = 'Paraksta augšupielādes laikā radās problēma. Lūdzu, mēģiniet vēlreiz.';
_fc_props.max_hotspot_unused_days_error = 'Maksimālais neizmantoto karsto punktu skaits dienās ir 1000 dienas.';
_fc_props.menu_dvir_title_admin_templates = 'Veidnes';
_fc_props.menu.dvir = {};
_fc_props.menu.dvir.admin = {};
_fc_props.menu.dvir.admin.title = 'Administrators';
_fc_props.cloud_dvir__admin_templates = 'Veidnes';
_fc_props.form_name = 'Veidlapas nosaukums';
_fc_props.form_status = 'Veidlapas statuss';
_fc_props.menu.dvir.title = 'DVIR';
_fc_props.cloud_dvir__option_download = 'Lejupielādēt';
_fc_props.cloud_dvir__option_view = 'Skatīt';
_fc_props.cloud_dvir__inspectortype_driver = 'Vadītājs';
_fc_props.menu.dvir.description = {};
_fc_props.menu.dvir.description.admin = 'Skatīt/rediģēt/izveidot pielāgotas DVIR veidlapas un iesniegumus';
_fc_props.menu.dvir.description.mechanic = 'Skatīt/rediģēt DVIR iesniegumus, par kuriem var iesniegt nepieciešamās darbības';
_fc_props.not_in_use = 'Netiek lietots';
_fc_props.logged_in = 'pieteicies';
_fc_props.reviewing_driver = 'Vadītāja pārskatīšana';
_fc_props.cloud_dvir__report_title = 'Vadītāja transportlīdzekļa pārbaudes ziņojums';
_fc_props.cloud_dvir__report_signed = 'parakstīts';
_fc_props.cloud_dvir__report_page_counter = '{0}. lappuse no {1}';
_fc_props.cloud_dvir__report_defects = 'Defekti';
_fc_props.cloud_dvir__report_comments = 'Komentāri';
_fc_props.cloud_dvir__report_inspection_table_title = 'Transportlīdzekļa pārbaude';
_fc_props.cloud_dvir__report_driver_table_title = 'Vadītāja informācija';
_fc_props.cloud_dvir__report_carrier = 'Pārvadātājs';
_fc_props.cloud_dvir__report_truck = 'Kravas automašīna';
_fc_props.cloud_dvir__report_location = 'Atrašanās vieta';
_fc_props.cloud_dvir__report_odometer = 'Odometrs';
_fc_props.cloud_dvir__report_hours = 'Stundas';
_fc_props.cloud_dvir__report_no_comments = 'Nav komentāru';
_fc_props.include_unlicensed_vehicles = 'Iekļaut nelicencētus transportlīdzekļus';
_fc_props.cloud_dvir__search_by_form_name = 'Meklēt pēc veidlapas nosaukuma';
_fc_props.cloud_dvir__create_dvir = 'Izveidojiet DVIR';
_fc_props.cloud_dvir__update_dvir = 'Atjaunināt DVIR';
_fc_props.cloud_dvir__form_name = 'Veidlapas nosaukums';
_fc_props.cloud_dvir__form_description = 'Veidlapas apraksts';
_fc_props.cloud_dvir__form_status = 'Veidlapas statuss';
_fc_props.information = 'Informācija';
_fc_props.cloud_dvir__search_categories = 'Meklēšanas kategorijas';
_fc_props.cloud_dvir__create_new_category = 'Izveidot jaunu kategoriju';
_fc_props.category_name = 'Kategorijas nosaukums';
_fc_props.sub_category = 'Apakškategorija';
_fc_props.sub_category_name = 'Apakškategorijas nosaukums';
_fc_props.delete_category = 'Dzēst kategoriju';
_fc_props.cloud_dvir__dvir_information = 'DVIR informācija';
_fc_props.cloud_dvir__dvir_choose_categories = 'Izvēlieties kategorijas';
_fc_props.cloud_dvir__create_category = 'Izveidot kategoriju';
_fc_props.cloud_dvir__update_category = 'Atjaunināt kategoriju';
_fc_props.delete_route_point = 'Dzēst maršruta punktu';
_fc_props.view_route_points = 'Skatīt maršruta punktus';
_fc_props.ignore_cancel_preload = 'Ignorējiet atcelšanu, jūsu dati ir iepriekš ielādēti. Jūsu mājas skrējiens drīz tiks parādīts.';
_fc_props.cloud_dvir__assigned_mechanic = 'Norīkotais mehāniķis';
_fc_props.cloud_dvir__add_mechanic = 'Pievienot mehāniķi';
_fc_props.contact_type = 'Kontaktpersonas veids';
_fc_props.cloud_dvir__send_email_notifications = 'Sūtīt e-pasta paziņojumus';
_fc_props.menu_dvir_title_admin_dvir = 'DVIR';
_fc_props.cloud_dvir__error_retrieving_dvir_history = 'Kļūda, izgūstot DVIR vēstures ierakstus.';
_fc_props.cloud_dvir__error_processing_dvir_record = 'Kļūda, izgūstot DVIR ierakstu.';
_fc_props.cloud_dvir__error_saving_submission = 'Kļūda, saglabājot iesniegumu. Mēģiniet vēlreiz.';
_fc_props.cloud_dvir__error_retrieving_mechanics = 'Kļūda, izgūstot mehāniku sarakstu.';
_fc_props.cloud_dvir__template_saved = 'Veidne saglabāta';
_fc_props.cloud_dvir__error_retrieving_dvir_templates = 'Kļūda, izgūstot veidņu sarakstu.';
_fc_props.cloud_dvir__error_saving_dvir_template = 'Kļūda, saglabājot veidni. Mēģiniet vēlreiz.';
_fc_props.dispatch_group = 'Dispečeru grupa';
_fc_props.save_adjust = 'Saglabāt un pielāgot maršruta punktu';
_fc_props.reset_route_point = 'Atiestatīt maršruta punktu';
_fc_props.no_records_stub_adjust_filters = 'Mēģiniet pielāgot meklēšanas vai filtra iestatījumus, lai palielinātu rezultātu skaitu.';
_fc_props.no_dvir_records = 'Visi nokļuvuši DVIR!';
_fc_props.no_dvir_records_sub_title = 'Jūs esat daudz paveicis';
_fc_props.settings.master_data_connex_x_api_key = 'Master Data Connex x-API-key';
_fc_props.slump_not_obtained_for_x = 'Nav iegūts krituma rādījums: {0}';
_fc_props.please_select_a_sensor_status_type = 'Lūdzu, atlasiet sensora statusa veidus, lai aktivizētu šo brīdinājumu.';
_fc_props.settings.master_data_connex_token = 'Galveno datu savienojuma žetons';
_fc_props.error_validating_master_data_connex_credentials = 'Kļūda, validējot Master Data Connex akreditācijas datus';
_fc_props.settings.master_data_connex_base_url = 'Galveno datu savienojuma bāzes URL';
_fc_props.settings.master_data_connex_exp_time = 'Galveno datu savienojuma derīguma termiņš';
_fc_props.download_template = 'Lejupielādēt veidni';
_fc_props.menu_settings_title_dispatch_group = 'Dispečeru grupas';
_fc_props.settings.dispatch_groups = 'Dispečeru grupas';
_fc_props.dispatch_group_name = 'Dispečeru grupas nosaukums';
_fc_props.dispatch_group_plants = 'Dispečeru grupas augi';
_fc_props.dispatch_group_plants_mapping_message = 'Norādiet, kuri augi būs daļa no šīs dispečeru grupas.';
_fc_props.dispatch_group_users_mapping_message = 'Norādiet, kuri lietotāji būs šīs dispečeru grupas dalībnieki.';
_fc_props.dispatch_group_plant_disassociation_message = 'Iekārtai vienlaikus jābūt pakļautai vienai dispečeru grupai.';
_fc_props.dispatch_group_search_by_plant = 'Meklēt pēc auga nosaukuma';
_fc_props.dispatch_group_search_by_username = 'Meklēt pēc lietotājvārda';
_fc_props.search_by_dispatch_group_name = 'Meklēt pēc dispečeru grupas nosaukuma';
_fc_props.create_dispatch_group = 'Izveidojiet dispečeru grupu';
_fc_props.update_dispatch_group = 'Atjaunināt dispečeru grupu';
_fc_props.dispatch_group_saved = 'Dispečeru grupa saglabāta';
_fc_props.warning_deleting_dispatch_group_unassociate_plants = 'Dzēšot šo dispečeru grupu, tiks izveidotas noklusējuma dispečeru grupas saistītajām rūpnīcām.';
_fc_props.error_saving_dispatch_group = 'Kļūda, saglabājot dispečeru grupu. Mēģiniet vēlreiz.';
_fc_props.please_enter_a_valid_plant_num = 'Lūdzu, ievadiet derīgu auga numuru.';
_fc_props.cloud_dvir__report_no_defects = 'Nav defektu';
_fc_props.shoud_select_dispatch_group = 'Jums jāizvēlas vismaz viena dispečeru grupa.';
_fc_props.one_or_more_users_are_associated_with_this_dispatch_group_only = 'Nevar dzēst, jo šajā dispečeru grupā ir lietotāji, kas ir saistīti tikai ar šo dispečeru grupu.';
_fc_props.cloud_dvir__username = 'Lietotājvārds';
_fc_props.cloud_dvir__password = 'Parole';
_fc_props.cloud_dvir__login = 'Pieteikšanās';
_fc_props.cloud_dvir__mechanic_sign_in = 'Mehāniķa pieteikšanās';
_fc_props.delete_dispatch_group = 'Dzēst dispečeru grupu';
_fc_props.cloud_dvir__driver = 'Vadītājs';
_fc_props.cloud_dvir__equipment_pound = 'Aprīkojuma nr.';
_fc_props.cloud_dvir__mechanic = 'Mehāniķis';
_fc_props.dispatch_group_user_only_unassociate_message = 'Nevar dzēst lietotāju, jo lietotājiem ir jābūt saistītiem ar vismaz vienu dispečeru grupu.';
_fc_props.cloud_dvir__time_period_filter_today = 'Šodien';
_fc_props.cloud_dvir__time_period_filter_yesterday = 'Vakar';
_fc_props.cloud_dvir__time_period_filter_last_7_days = 'Pēdējās 7 dienas';
_fc_props.cloud_dvir__time_period_filter_last_30_days = 'Pēdējās 30 dienas';
_fc_props.cloud_dvir__date_range_filter = 'Filtrēt pēc datuma';
_fc_props.cloud_dvir__download = 'Lejupielādēt';
_fc_props.dispatch_group_is_empty = 'Dispečeru grupas lauks nedrīkst būt tukšs.';
_fc_props.dispatch_group_with_empty_plants = 'Vismaz vienai iekārtai jābūt saistītai ar dispečeru grupu.';
_fc_props.dispatch_group_with_empty_users = 'Vismaz vienam lietotājam ir jābūt saistītam ar dispečeru grupu.';
_fc_props.not_delete_one_or_more_users_are_associated_with_this_dispatch_group_only = 'Nevar izdzēst dispečeru grupu, jo tajā ir lietotāji, kas ir saistīti tikai ar šo dispečeru grupu.';
_fc_props.dispatch_group_not_exists = 'Dispečeru grupa nepastāv.';
_fc_props.dispatch_group_contains_one_plant = 'Nevar dzēst, jo šajā dispečeru grupā ir tikai viens augs.';
_fc_props.dispatch_group_users = 'Dispečeru grupas lietotāji';
_fc_props.cloud_dvir__error_retrieving_dvir = 'Kļūda, izgūstot DVIR ierakstu';
_fc_props.cloud_dvir__assign_mechanic = 'Piešķirt mehāniķi';
_fc_props.cloud_dvir__submit_review = 'Iesniegt atsauksmi';
_fc_props.error_deleting_dispatch_group = 'Kļūda, dzēšot nosūtīšanas grupu.';
_fc_props.error_retrieving_dispatch_groups = 'Kļūda, izgūstot nosūtīšanas grupu sarakstu.';
_fc_props.cloud_dvir__undo_selection = 'Atsaukt atlasi';
_fc_props.enable_master_data = 'Iespējot galvenos datus';
_fc_props.manually_sync = 'Manuāla sinhronizācija';
_fc_props.master_data_connex_token_expiration = 'Galveno datu savienojuma marķiera derīguma termiņš';
_fc_props.cloud_dvir__time_period_filter_custom = 'Pielāgots';
_fc_props.settings.zello_session_timeout_minutes = 'Zello sesijas taimauts (minūtēs)';
_fc_props.menu_settings_title_master_data = 'Galvenie dati';
_fc_props.settings.master_data = 'Galvenie dati';
_fc_props.error_retrieving_master_data = 'Kļūda, izgūstot galvenos datus';
_fc_props.master_data_sync_completed = 'Galveno datu sinhronizācija pabeigta';
_fc_props.master_data_successfully_updated = 'Dati veiksmīgi atjaunināti';
_fc_props.master_data_failed_to_update = 'Neizdevās saglabāt.';
_fc_props.master_data_sync_initiated = 'Uzsākta galveno datu sinhronizācija';
_fc_props.master_data_sync_failed = 'Galveno datu sinhronizācija neizdevās';
_fc_props.enabled_excluding_origin_on_deliveries = 'Patiesi (izņemot izcelsmes vietu piegādes kvītīs)';
_fc_props.enabled_including_origin_on_deliveries = 'Patiesi (ieskaitot izcelsmi piegādes kvītīs)';
_fc_props.cloud_dvir__i_will_decide_later = 'Es izlemšu vēlāk';
_fc_props.returning = 'Atgriežoties';
_fc_props.leftover_concrete = 'Atlikušais betons';
_fc_props.leftover_concrete_on_vehicle_x = 'Atlikušais betons uz transportlīdzekļa {0}';
_fc_props.leftover_concrete_alert = 'Brīdinājums par betona paliekām';
_fc_props.wc_ratio_exceeded = 'Ūdens/sausuma attiecība pārsniegta';
_fc_props.search_by_site_name = 'Meklēt pēc vietnes nosaukuma';
_fc_props.sites = 'Vietnes';
_fc_props.token_expiration = 'Žetona derīguma termiņš';
_fc_props.menu_settings_title_connex_api_key_management = 'Connex API atslēgu pārvaldība';
_fc_props.settings.connex_api_key_management = 'Connex API atslēgu pārvaldība';
_fc_props.error_retrieving_connex_api_key_data = 'Kļūda, izgūstot Connex API atslēgas datus';
_fc_props.qr_code = 'QR kods';
_fc_props.informing_driver_and_interface_when_entering_wrong_plant = 'Vadītāja un saskarnes informēšana, ja tiek ievadīts nepareizs objekts';
_fc_props.enable_driver_message = 'Iespējot vadītāja ziņojumu';
_fc_props.enable_dispatch_message = 'Iespējot nosūtīšanas ziņojumu';
_fc_props.enable_sending_message_to_interface = 'Iespējot ziņojuma sūtīšanu uz saskarni';
_fc_props.ticket_qr_code = 'QR kods';
_fc_props.leftover_concrete_alert_description = 'Brīdinājums, ja pēc betona ieliešanas tiek atrastas betona paliekas.';
_fc_props.minimum_leftover_concrete_amount = 'Minimālais atlikušā betona daudzums';
_fc_props.error_validating_master_data_connex_credentials_unauthorized = 'Kļūda, validējot galvenos datus. Connex akreditācijas dati nav autorizēti.';
_fc_props.error_validating_master_data_connex_credentials_permissions = 'Kļūda, validējot galveno datu savienojuma akreditācijas datu atļaujas.';
_fc_props.error_validating_master_data_connex_url_not_found = 'Kļūda, validējot galveno datu savienojuma URL, nav atrasts.';
_fc_props.error_validating_master_data_connex_unknown_error = 'Kļūda, validējot galvenos datus Connex, nezināma kļūda.';
_fc_props.master_data_sync_failed_sync_up_vehicle_type = 'Galveno datu sinhronizācija neizdevās. Sinhronizējiet transportlīdzekļa tipu.';
_fc_props.master_data_sync_failed_sync_up_vehicle = 'Galveno datu sinhronizācija neizdevās. Sinhronizējiet transportlīdzekli.';
_fc_props.master_data_sync_failed_sync_up_plant = 'Galveno datu sinhronizācija neizdevās. Sinhronizējiet iekārtu.';
_fc_props.master_data_sync_failed_data_base_connection = 'Galveno datu sinhronizācijas savienojums ar datubāzi neizdevās.';
_fc_props.error_validating_master_data_connex_permission_is_insufficient = 'Kļūda, validējot galvenos datus Connex akreditācijas dati. Nesēja marķiera atļauja nav pietiekama.';
_fc_props.settings.back_date_arrive_job = 'Darba ierašanās datums atpakaļ';
_fc_props.device_notifications = 'Paziņojumi';
_fc_props.loading_number = 'Iekraušanas numurs';
_fc_props.leftover_concrete_volume_temp_age = 'Atlikušais tilpums={0}, Pagaidu laiks={1}, Vecums={2}';
_fc_props.total_ordered = 'Kopējais pasūtītais daudzums';
_fc_props.total_ticketed = 'Piegādāts Pasūtīts';
_fc_props.load_number = 'Kravas numurs';
_fc_props.min_leftover_concrete_must_be_filled_in_and_gt_x = 'Minimālais atlikušā betona daudzums ir jāaizpilda, un tas ir lielāks par {0}';
_fc_props.error_validating_master_data_connex_credentials_are_the_same = 'Kļūda, validējot pamatdatus. Akreditācijas dati nevar būt vienādi.';
_fc_props.use_aws_for_talk = 'Izmantojiet AWS sarunām';
_fc_props.air_readings_not_supported = 'Gaisa rādījumi netiek atbalstīti';
_fc_props.air_not_supported = 'Gaiss netiek atbalstīts';
_fc_props.mix_not_supported = 'Mikss netiek atbalstīts';
_fc_props.air_default_and_none_not_supported = 'Nevar vienlaikus atlasīt noklusējuma un neatbalstīto!';
_fc_props.notifications_enabled = 'Paziņojumi iespējoti';
_fc_props.prevent_status_change = 'Novērst statusa maiņu';
_fc_props.message_to_interface = 'Ziņojums saskarnei';
_fc_props.prevent_wrong_plant = 'Novērst nepareizu stādīšanu';
_fc_props.previous_tickets = 'Iepriekšējās biļetes';
_fc_props.audit_ticket_number = 'Biļetes numurs';
_fc_props.audit_date_created = 'Izveidošanas datums';
_fc_props.audit_vehicle_number = 'Transportlīdzekļa numurs';
_fc_props.cloud_dvir__table_ok = 'Droši lietojams';
_fc_props.cloud_dvir__table_needs_repair = 'Nedrošs ekspluatācijā';
_fc_props.missing_air_calibration = 'Nav gaisa kalibrēšanas datu';
_fc_props.reported_defects = 'Ziņotie defekti';
_fc_props.address_latitude = 'Adrese Platums';
_fc_props.address_longitude = 'Adreses garums';
_fc_props.routing_latitude = 'Maršrutēšanas platums';
_fc_props.routing_longitude = 'Maršruta garums';
_fc_props.category_name_must_be_unique = 'Kategorijas nosaukumam jābūt unikālam';
_fc_props.subcategory_name_must_be_unique = 'Apakškategorijas nosaukumam jābūt unikālam';
_fc_props.menu_settings_tracking_device = 'Izsekošanas ierīce';
_fc_props.menu_settings_title_tracking_device = 'Izsekošanas ierīce';
_fc_props.menu_settings_title_personal_device_registration = 'Personīgās ierīces reģistrācija';
_fc_props.registration_code = 'Reģistrācijas kods';
_fc_props.creation_date = 'Radīšana';
_fc_props.expiration_date = 'Derīguma termiņš';
_fc_props.trackitadmin_personal_device_registration = 'Personīgās ierīces reģistrācija';
_fc_props.create_registration_code = 'Pievienot reģistrācijas kodu';
_fc_props.remove_registration_code = 'Noņemt reģistrācijas kodu';
_fc_props.add_a_registration_code = 'Pievienot reģistrācijas kodu';
_fc_props.select_number_of_registration_codes_to_generate = 'Atlasiet ģenerējamo reģistrācijas kodu skaitu.';
_fc_props.registration_code_count = 'Reģistrācijas kodu skaits';
_fc_props.are_you_sure_you_want_to_delete_this_reg_code = 'Vai tiešām vēlaties dzēst atlasīto reģistrēto kodu?';
_fc_props.are_you_sure_you_want_to_delete_selected_reg_codes = 'Vai tiešām vēlaties dzēst atlasītos reģistrētos kodus?';
_fc_props.add_personal_device = 'Pievienot personīgo ierīci';
_fc_props.menu_settings_title_personal_device = 'Personīgā ierīce';
_fc_props.cloud_dvir__approval_critical_alert = 'Transportlīdzeklim ir kritisks defekts. To nevar atzīmēt kā drošu ekspluatācijai.';
_fc_props.export_registration_codes = 'Eksporta reģistrācijas kodi';
_fc_props.download_format = 'Lejupielādes formāts';
_fc_props.specify_download_format_x = 'Norādiet lejupielādes formātu, lai eksportētu {0} reģistrācijas kodus';
_fc_props.personal_device_download = 'Lejupielādēt';
_fc_props.add_personal_device_input_message = 'Ievadiet personīgās ierīces ID zemāk. Derīguma termiņš tiks automātiski piemērots pēc saglabāšanas.';
_fc_props.error_creating_personal_device = 'Kļūda, veidojot personīgo ierīci';
_fc_props.device_already_exists = 'Personīgā ierīce jau pastāv';
_fc_props.export = 'Eksportēt';
_fc_props.error_can_not_change_connex_eid = 'Nevar mainīt connex eid, jo tas pašlaik tiek izmantots galvenajiem datiem.';
_fc_props.remove_personal_device = 'Noņemt personīgo ierīci';
_fc_props.are_you_sure_you_want_to_delete_this_personal_device = 'Vai tiešām vēlaties dzēst atlasīto personīgo ierīci?';
_fc_props.are_you_sure_you_want_to_delete_selected_personal_devices = 'Vai tiešām vēlaties dzēst atlasītās personīgās ierīces?';
_fc_props.error_deleting_personal_device = 'Kļūda, dzēšot personīgo ierīci';
_fc_props.customerid = 'Klienta ID';
_fc_props.customername = 'Klienta vārds';
_fc_props.ordernumber = 'Pasūtījuma numurs';
_fc_props.orderdescription = 'Pasūtījuma apraksts';
_fc_props.locationid = 'Atrašanās vietas ID';
_fc_props.locationdescription = 'Atrašanās vietas apraksts';
_fc_props.productid = 'Produkta ID';
_fc_props.productdescription = 'Produkta apraksts';
_fc_props.vehicleid = 'Transportlīdzekļa ID';
_fc_props.vehicledescription = 'Transportlīdzekļa apraksts';
_fc_props.ticketnumber = 'Biļetes nr.';
_fc_props.ticketdate = 'Biļetes datums/laiks';
_fc_props.drivername = 'Vadītāja vārds';
_fc_props.arriveregion = 'Ierašanās reģions (TIME)';
_fc_props.leaveregion = 'Atstāt reģionu (TIME)';
_fc_props.regionduration = 'Reģiona ilgums';
_fc_props.menu_reports_title_prevailing_wage = 'Dominējošā alga';
_fc_props.slump_calibration_x_not_found_for_y = 'Biļetei {1} nav atrasta lejupslīdes kalibrēšana "{0}"';
_fc_props.slump_calibration_not_found = 'Lejupslīdes kalibrēšana nav atrasta';
_fc_props.slump_calibration_not_found_description = 'Brīdinājums, ja nav atrasta noslīdes kalibrēšana';
_fc_props.error_getting_personal_device_list = 'Kļūda, iegūstot personīgo ierīču sarakstu';
_fc_props.batch_summary_date_range_note = '*PIEZĪME. Ja netiek lietoti filtri, šajā pārskatā ir iekļauts 3 dienu ierobežojums. Filtrējot pēc aprīkojuma (maksimums 10), rūpnīcas (maksimums 1), produkta (maksimums 1) vai darba (maksimums 1), datumu diapazons var sasniegt 31 dienu.';
_fc_props.select_registration_code_expiration_time_days = 'Atlasiet dienu skaitu līdz reģistrācijas kodu derīguma termiņa beigām un pēc tam noklikšķiniet uz Saglabāt.';
_fc_props.add_personal_device_expiration = 'Derīguma termiņš (dienās)';
_fc_props.cloud_dvir__vehicle_no = 'Transportlīdzekļa Nr.';
_fc_props.cloud_dvir__trailer_no = 'Piekabes Nr.';
_fc_props.cloud_dvir__vehicle = 'Transportlīdzeklis';
_fc_props.cloud_dvir__trailer = 'Piekabe';
_fc_props.cloud_dvir__truck_number_label = 'Kravas automašīnas numurs';
_fc_props.cloud_dvir__trailer_number = 'Piekabes numurs';
_fc_props.cloud_dvir__has_trailer = 'Nebrauc ar piekabi';
_fc_props.cloud_dvir__trailer_input_field_prompt = 'Ievadiet šeit savas piekabes numuru';
_fc_props.work_order = 'Darba uzdevums';
_fc_props.unable_to_determine_slump = 'Nevar noteikt kritumu';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_trailer = 'Nosakiet piekabes vispārējo stāvokli';
_fc_props.defaultTrailer = 'Noklusējuma treileris';
_fc_props.trailer_type_column_billable = 'Apmaksājams';
_fc_props.trailer_type_column_notes = 'Piezīmes';
_fc_props.trailer_type_column_date = 'Datums';
_fc_props.trailer_type_column_order = 'Pasūtījums';
_fc_props.trailer_type_column_ticket = 'Biļete';
_fc_props.trailer_type_column_project = 'Projekts';
_fc_props.trailer_type_column_customer = 'Klients';
_fc_props.trailer_type_column_location = 'Atrašanās vieta';
_fc_props.trailer_type_column_vehicle_type = 'Transportlīdzekļa tips';
_fc_props.trailer_type_column_product = 'Produkts';
_fc_props.trailer_type_action_rebill = 'Atkārtoti norēķināties';
_fc_props.master_data_sync_failed_no_default_vehicle_type_has_been_set = 'Galveno datu sinhronizācija neizdevās, nav iestatīts noklusējuma aprīkojuma tips.';
_fc_props.trailer_type = 'Piekabes tips';
_fc_props.trailer_type_is_required = 'Nepieciešams piekabes tips';
_fc_props.trailer_number_already_exists = 'Piekabes numurs jau pastāv';
_fc_props.plate_number_already_exists = 'Valsts numura zīme jau pastāv';
_fc_props.trailer_vin_already_exists = 'Treilera Vin jau pastāv';
_fc_props.trailer_does_not_exist = 'Treileris neeksistē';
_fc_props.trailer_number_is_required = 'Nepieciešams piekabes numurs';
_fc_props.plate_number_is_required = 'Nepieciešams numura zīmes numurs';
_fc_props.plate_number = 'Numura zīme';
_fc_props.menu_settings_title_trailer = 'Piekabe';
_fc_props.add_trailer = 'Pievienot reklāmkadru';
_fc_props.edit_trailer = 'Rediģēt reklāmkadru';
_fc_props.menu_settings_title_equipment = 'Aprīkojums';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes = 'Ignorēt jaunas biļetes no Command Cloud, kas vecākas par X minūtēm';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes_title = 'Ignorēt jaunas biļetes no Command Cloud, kuru nosūtīšanas datums un laiks ir vecāks par X minūtēm (pēc noklusējuma ir tukšs un izslēgts)';
_fc_props.edit_load_card = 'Rediģēt ielādes karti';
_fc_props.default_layout = 'Noklusējuma izkārtojums';
_fc_props.load_card_empty_fields = 'Kļūda, saglabājot ielādes karti: Jāatlasa viens vai vairāki lauki.';
_fc_props.trailers = 'Piekabes';
_fc_props.error_failed_to_save_data = 'Kļūda: Neizdevās saglabāt datus';
_fc_props.slump_increased_plasticizer_added_question = 'Cik daudz plastifikatora tika pievienots?';
_fc_props.add_trailer_type = 'Pievienot piekabes veidu';
_fc_props.menu_settings_title_trailer_type = 'Piekabes tips';
_fc_props.edit_trailer_type = 'Rediģēt reklāmkadru veidu';
_fc_props.single_use_codes = 'Vienreizējās lietošanas kodi';
_fc_props.multiple_use_codes = 'Vairākkārt lietojami kodi';
_fc_props.trailer_type_description_is_required = 'Nepieciešams piekabes tipa apraksts';
_fc_props.trailer_saved = 'Treileris saglabāts';
_fc_props.cloud_dvir__trailer_only_dvir = 'Tikai treileris DVIR';
_fc_props.choose_file = 'Izvēlieties failu';
_fc_props.no_file_chosen = 'Nav izvēlēts fails';
_fc_props.please_choose_file = 'Lūdzu, izvēlieties failu';
_fc_props.no_filters = 'Nav atlasītu filtru';
_fc_props.remaining_defects = 'Atlikušie defekti';
_fc_props.load_more = 'Ielādēt vairāk';
_fc_props.pagination_label = '{0}-{1} no {2}';
_fc_props.extend = 'Paplašināt';
_fc_props.cloud_dvir__notes_or_photo_required = 'Nepieciešamas vai nu piezīmes, vai fotoattēls.';
_fc_props.no_default_plant_specified_failed_to_save = 'Nav norādīta noklusējuma iekārta.';
_fc_props.no_default_employee_type_specified_failed_to_save = 'Nav norādīts noklusējuma darbinieka tips.';
_fc_props.personal_device_registration_code_saved = 'Personīgās ierīces reģistrācijas kods ir saglabāts.';
_fc_props.error_saving_personal_device_registration_code = 'Kļūda, saglabājot personīgās ierīces reģistrācijas kodu. Mēģiniet vēlreiz.';
_fc_props.settings.master_data_sub_title = 'Iestatiet galveno datu integrāciju starp TrackIt un Connex';
_fc_props.connex_authentication = '{0} Autentifikācija';
_fc_props.select_company = 'Izvēlieties uzņēmumu';
_fc_props.requirements = 'Prasības';
_fc_props.default_plant_type = 'Noklusējuma iekārta';
_fc_props.default_employee_type = 'Noklusējuma darbinieka tips';
_fc_props.default_equipment_type = 'Noklusējuma aprīkojuma veids';
_fc_props.support_alphanumeric_trucks = 'Atbalstiet burtciparu kravas automašīnas';
_fc_props.no_default_equipment_type_specified_failed_to_save = 'Nav norādīts noklusējuma aprīkojuma tips.';
_fc_props.air_pau_battery_low_message = 'Air PAU akumulatora izlādes brīdinājums';
_fc_props.air_pau_battery_low = 'Gaisa PAU akumulatora uzlādes līmenis ir zems';
_fc_props.alert_when_air_pau_battery_low = 'Brīdinājums, kad Air PAU akumulatora uzlādes līmenis ir zems';
_fc_props.air_pau_battery_low_alert = 'Brīdinājums par zemu gaisa akumulatora uzlādes līmeni';
_fc_props.sensor_unable_to_determine_slump = 'Sensors nevar noteikt kritumu';
_fc_props.menu_settings_title_export = 'Eksportēt';
_fc_props.compare_company = 'Salīdzināt ar citu uzņēmumu';
_fc_props.site_settings = 'Vietnes iestatījumi';
_fc_props.permission_type = 'Atļaujas veids';
_fc_props.ticket_integration = 'Biļešu integrācija';
_fc_props.select_one_or_more_settings = 'Lūdzu, atlasiet vienu vai vairākus iestatījumus';
_fc_props.export_tooltip = 'Šī opcija ir pieejama tikai tad, ja piederat vairākiem uzņēmumiem.';
_fc_props.select_company_error = 'Lūdzu, izvēlieties uzņēmumu';
_fc_props.audible = 'Dzirdams';
_fc_props.deleted_master_data_successfully = 'Galvenie dati veiksmīgi izdzēsti';
_fc_props.cloud_dvir__units_miles_abbr = 'MI';
_fc_props.cloud_dvir__units_kilometers_abbr = 'KM';
_fc_props.create_hauler_order = 'Izveidot pārvadātāja pasūtījumu';
_fc_props.send_gps = 'Sūtīt GPS';
_fc_props.cloud_dvir__search_results = 'Meklēšanas rezultāti';
_fc_props.cloud_dvir__advanced_filter = 'Paplašinātā filtrēšana';
_fc_props.preload = 'Iepriekšēja ielāde';
_fc_props.job_name = 'Amata nosaukums';
_fc_props.delivery_address = 'Piegādes adrese';
_fc_props.total_water_added = 'Kopējais pievienotā ūdens daudzums';
_fc_props.total_customer_water_added = 'Kopējais klienta pievienotā ūdens daudzums';
_fc_props.concrete_volume = 'Betona tilpums';
_fc_props.water_events_and_volume = 'Ūdens notikumi un apjoms';
_fc_props.menu.reports.title.water_events_and_volume = 'Ūdens notikumi un apjoms';
_fc_props.menu.reports.description = {};
_fc_props.menu.reports.description.water_events_and_volume = 'Skatiet pievienoto ūdeni biļetēm dažādos statusos un grupās';
_fc_props.returned_concrete_volume = 'Atgrieztā betona tilpums';
_fc_props.customer_water_added = 'Klienta pievienotais ūdens';
_fc_props.averages_and_totals = 'Vidējie rādītāji un kopsummas';
_fc_props.preload_loading = 'Iepriekšēja ielāde';
_fc_props.preload_loaded = 'Ielādēts pirms ielādes';
_fc_props.send = 'Sūtīt';
_fc_props.deliveries_iframe_url = 'Piegādes IFrame URL';
_fc_props.bulk_ticket_completion = 'Lielapjoma pieprasījuma pabeigšana';
_fc_props.ticket_type = 'Biļetes veids';
_fc_props.complete_tickets = 'Pilnīgas biļetes';
_fc_props.tickets_found = 'Atrasts(-i) biļete(-i)';
_fc_props.include_preload = 'Iekļaut iepriekšēju ielādi';
_fc_props.exclude_preload = 'Izslēgt iepriekšēju ielādi';
_fc_props.selected_tickets = 'Atlasītās biļetes';
_fc_props.are_you_sure_you_want_to_complete_selected_tickets = 'Vai tiešām vēlaties pabeigt atlasīto biļešu apstrādi?';
_fc_props.completing_tickets = 'Biļešu_aizpildīšana';
_fc_props.some_tickets_failed_to_complete = 'Dažas biļetes neizdevās pabeigt';
_fc_props.bulk_ticket_complete_failed = 'Neizdevās pabeigt masveida pieprasījumu';
_fc_props.ticket_management = 'Biļešu pārvaldība';
_fc_props.invalid_url_for_deliveries = 'Nederīga piegāžu URL adrese';
_fc_props.menu_dvir_title_translations = 'Tulkojumi';
_fc_props.cloud_dvir__dvir_translation = 'Tulkojums';
_fc_props.template = 'Veidne';
_fc_props.menu_dvir_title_admin_translations = 'Tulkojumi';
_fc_props.menu.dvir.description.translations = 'Skatīt DVIR tulkojumus';
_fc_props.cloud_dvir__driver_review = 'Vadītāja apskats';
_fc_props.cloud_dvir__mechanic_review = 'Mehāniķa apskats';
_fc_props.cloud_dvir__driver_approval = 'Vadītāja apstiprinājums';
_fc_props.cloud_dvir__dvir_event_type = 'DVIR notikuma veids';
_fc_props.cloud_dvir__option_print_signed = 'Drukāts paraksts';
_fc_props.deliveries_cloud_auth_enabled = 'Piegādēm izmantot mākoņa autentifikāciju';
_fc_props.deliveries_host_name = 'Piegāžu resursdatora nosaukums';
_fc_props.cloud_dvir__option_event_history = 'Notikumu vēsture';
_fc_props.ticketed_plant = 'Biļešu rūpnīca';
_fc_props.cloud_dvir__all_notes_and_photos_will_be_removed = 'Visas piezīmes un fotoattēli tiks noņemti';
_fc_props.cloud_dvir__continue = 'Turpināt';
_fc_props.cloud_dvir__cancel = 'Atcelt';
_fc_props.engine_diagnostic_canbaudrate_1 = 'VAR 1';
_fc_props.engine_diagnostic_canbaudrate_2 = 'VAR 2';
_fc_props.attached = 'Pievienots';
_fc_props.cloud_dvir__images = 'Attēli';
_fc_props.settings.ticket_voided_status_change = 'Kad biļete ir anulēta, mainīt statusu uz';
_fc_props.ticket_voided_status_change_duplication_error = 'Anulētas biļetes statusa maiņa: Katrai statusa cilpai var izvēlēties tikai vienu statusu';
_fc_props.cloud_not_sending_events = 'Mākoņa entītijas ID ir iestatīts, bet notikumi netiek sūtīti uz mākoni.';
_fc_props.set_ticket_integration_send_to_event_bus = 'Biļešu integrācijas iestatījumos iestatiet statusa/atrašanās vietas sūtīšanas uz notikumu tiltu vērtību “true”.';
_fc_props.cloud_missing_loading = 'Mākoņa integrācija ar statusu LOADING, kas nozīmē, ka statusa tips nav iestatīts';
_fc_props.cloud_assign_loading = 'Piešķiriet IELĀDES statusa nozīmi, lai notiktu ielādes statusa maiņa no mākoņa';
_fc_props.cloud_missing_loaded = 'Mākoņa integrācija ar statusu LOADED, kas nozīmē, ka statusa tips nav iestatīts';
_fc_props.cloud_assign_loaded = 'Piešķiriet statusu LOADED (IELĀDĒTS), lai notiktu ielādes statusa maiņa no mākoņa';
_fc_props.employee_no_valid_type = 'Darbinieki, kuriem nav piešķirts derīgs darbinieka tips';
_fc_props.employee_assign_valid_type = 'Pārliecinieties, vai visiem darbiniekiem ir piešķirts derīgs darbinieka tips.';
_fc_props.employee_no_valid_home_plant = 'Darbinieki, kuriem nav piešķirta derīga mājas iekārta';
_fc_props.employee_assign_valid_home_plant = 'Pārliecinieties, ka visiem darbiniekiem ir piešķirta mājas iekārta';
_fc_props.employee_dup_alt_num = 'Darbinieki ar dublētu alternatīvo darbinieka numuru';
_fc_props.employee_fix_dup_alt_num = 'Pārliecinieties, vai visiem darbiniekiem ir unikāls alternatīvs darbinieka numurs';
_fc_props.employee_type_no_default = 'Nav noklusējuma darbinieka tipa';
_fc_props.employee_type_assign_default = 'Iestatiet noklusējuma darbinieka tipu';
_fc_props.equipment_type_no_default = 'Nav noklusējuma aprīkojuma veida';
_fc_props.equipment_type_assign_default = 'Iestatiet noklusējuma aprīkojuma veidu';
_fc_props.equipment_type_not_used = 'Nepiešķirtie aprīkojuma veidi';
_fc_props.equipment_type_assign_not_used = 'Noņemiet neizmantotos aprīkojuma veidus';
_fc_props.equipment_no_valid_type = 'Aprīkojums bez piešķirta derīga aprīkojuma tipa';
_fc_props.equipment_assign_valid_type = 'Pārliecinieties, vai visām iekārtām ir piešķirts derīgs iekārtu tips.';
_fc_props.equipment_no_valid_home_plant = 'Iekārtas bez piešķirtas derīgas mājas iekārtas';
_fc_props.equipment_assign_valid_home_plant = 'Pārliecinieties, vai visām iekārtām ir piešķirta mājas iekārta.';
_fc_props.equipment_no_valid_last_plant = 'Iekārtas bez derīgas piešķirtas pēdējās rūpnīcas';
_fc_props.equipment_assign_valid_last_plant = 'Pārliecinieties, vai visām iekārtām ir piešķirta pēdējā iekārta.';
_fc_props.equipment_dup_interface_num = 'Iekārtas ar dublētiem saskarnes numuriem';
_fc_props.equipment_fix_dup_interface_num = 'Pārliecinieties, vai visām iekārtām ir unikāls saskarnes numurs.';
_fc_props.equipment_no_vin = 'Aprīkojums ar mākoņa DVIR, bet bez vin koda';
_fc_props.equipment_assign_vin = 'Atjauniniet aprīkojumu, lai iegūtu vin numuru';
_fc_props.equipment_probe_no_drum_type = 'Iekārta ar zondes licenci, bet bez cilindra tipa';
_fc_props.equipment_probe_assign_drum_type = 'Atjauniniet aprīkojumu, lai tam būtu bungu tips';
_fc_props.equipment_drs_no_drum_type = 'Aprīkojums ar trumuļa rotācijas sensoru, bet bez trumuļa tipa';
_fc_props.equipment_drs_assign_drum_type = 'Atjauniniet aprīkojumu, lai tam būtu bungu tips';
_fc_props.equipment_ed_no_config = 'Aprīkojums ar dzinēja diagnostikas licenci un bez konfigurācijas';
_fc_props.equipment_ed_assign_no_config = 'Atjauniniet aprīkojumu, lai tam būtu dzinēja diagnostikas konfigurācija';
_fc_props.plant_no_dispatch_group = 'Augi bez dispečeru grupas';
_fc_props.plant_assign_dispatch_group = 'Piešķiriet augus esošajām dispečeru grupām vai saglabājiet augus atkārtoti, lai piešķirtu dispečeru grupas';
_fc_props.plant_dup_num = 'Augs ar dublētiem augu numuriem';
_fc_props.plant_fix_dup_num = 'Pārliecinieties, ka visiem augiem ir unikāli numuri.';
_fc_props.plant_dup_interface_num = 'Iekārta ar dublētiem saskarnes numuriem';
_fc_props.plant_fix_dup_interface_num = 'Pārliecinieties, vai visām iekārtām ir unikāls saskarnes numurs.';
_fc_props.status_types_no_default_hotspot_type = 'Statusa tipiem trūkst noklusējuma karstvietas tipa';
_fc_props.status_types_assign_default_hotspot_type = 'Iestatiet noklusējuma karstvietas veidu katram statusa veidam';
_fc_props.hotspot_type_no_valid_enter_status = 'Karstvietas veids, ievadiet statusu, vairs nepastāv';
_fc_props.hotspot_type_assign_valid_enter_status = 'Atjauniniet tīklāja veidu, lai tam būtu derīgs ievades statuss vai tā nebūtu.';
_fc_props.hotspot_type_no_valid_exit_status = 'Karstvietas tipa izejas statuss vairs nepastāv';
_fc_props.hotspot_type_assign_valid_exit_status = 'Atjauniniet karstvietas veidu, lai tam būtu derīgs izejas statuss vai tā nebūtu.';
_fc_props.hotspot_type_not_usable = 'Karstpunkta tips pastāv statusa tipam, kas nav piešķirts nevienam aprīkojuma tipam.';
_fc_props.hotspot_type_fix_not_usable = 'Pārbaudiet karsto punktu tipa izmantošanu; ja šāda veida karstie punkti tiek izveidoti, tie netiks parādīti kartē.';
_fc_props.hotspot_invalid_hotspot_type = 'Pastāvīgajam tīklājam trūkst tīklāja veida';
_fc_props.hotspot_assign_hotspot_type = 'Atjauniniet tīklāju, lai tam būtu derīgs tīklāja veids.';
_fc_props.plant_hotspot_conflict = 'Augu karstvietai ir pretrunīga augu piešķiršana';
_fc_props.plant_hotspot_fix_conflict = 'Augam piešķirtā iekārta atšķiras no auga, kas piešķirts biļetes piešķirē, pārbaudiet auga piešķiršanu karstajā punktā, iespējams, būs jāizveido auga karstais punkts atkārtoti, lai to atrisinātu.';
_fc_props.plant_hotspot_restricted = 'Augu piekļuves punkts ir ierobežots noteiktām biļetēm';
_fc_props.plant_hotspot_fix_restricted = 'Augu karstais punkts ir ierobežots noteiktām biļetēm, lai to atrisinātu, ir nepieciešams atkārtoti izveidot augu karsto punktu.';
_fc_props.status_type_not_used = 'Statusa tips nav piešķirts nevienam aprīkojuma tipam';
_fc_props.status_type_fix_not_used = 'Iesakām dzēst statusa veidu, ja tas nav nepieciešams.';
_fc_props.status_type_no_first = 'Trūkst statusa veida Pirmais statuss';
_fc_props.status_type_fix_no_first = 'Piešķirt pirmo statusu statusa tipam';
_fc_props.status_type_no_last = 'Trūkst statusa veida Pēdējais statuss';
_fc_props.status_type_fix_no_last = 'Piešķiriet pēdējo statusu statusa tipam';
_fc_props.question_no_input_format = 'Jautājumam trūkst ievades formāta';
_fc_props.question_assign_input_format = 'Piešķiriet jautājumam formātu';
_fc_props.ticket_no_concrete_product = 'Biļete par DRS vai zondi un trūkstošs kubikjards vai kubikmetrs UOM uz produkta';
_fc_props.ticket_fix_no_concrete_product = 'Pārbaudiet pieteikuma avotu un pārliecinieties, vai integrācija nosūta pareizo mērvienību.';
_fc_props.ticket_preload_no_status_meaning = 'Biļešu iepriekšēja ielāde, bet trūkst iepriekšējas ielādes statusa nozīmes';
_fc_props.ticket_preload_assign_status_meaning = 'Iestatīšanas statusa nozīmes iepriekšējas ielādes biļetēm';
_fc_props.question_setup_no_end_miles = 'Jautājuma iestatīšanas brīdī ir iestatītas tikai sākuma jūdzes.';
_fc_props.question_setup_assign_end_miles = 'Atjauniniet jautājuma iestatījumus, lai iekļautu gan sākuma, gan beigu jūdzes';
_fc_props.question_setup_no_begin_miles = 'Jautājuma iestatīšanas brīdī ir iestatītas tikai beigu jūdzes.';
_fc_props.question_setup_no_end_hours = 'Jautājuma iestatīšanas laikā ir iestatīts tikai sākuma laiks.';
_fc_props.question_setup_assign_end_hours = 'Atjauniniet jautājuma iestatījumus, lai iekļautu gan sākuma, gan beigu stundas';
_fc_props.question_setup_no_begin_hours = 'Jautājuma iestatīšanas laikā ir iestatīts tikai beigu laiks.';
_fc_props.question_setup_no_last_plant = 'Jautājuma iestatīšana nenosaka pēdējo iekārtu';
_fc_props.question_setup_assign_last_plant = 'Atjaunināt jautājuma iestatījumus, lai iekļautu iestatījumu Pēdējā iekārta aprīkojumam';
_fc_props.device_not_used = 'Aktīva ierīce, kas nav izmantota pēdējo 6 mēnešu laikā';
_fc_props.device_delete_not_used = 'Pārbaudiet, vai ierīces joprojām ir nepieciešamas';
_fc_props.cloud_integration = 'Mākoņa integrācija';
_fc_props.user_not_used = 'Vietnes lietotāji nav pieteikušies vairāk nekā 6 mēnešus';
_fc_props.user_delete_not_used = 'Noņemt lietotājus, kuri nepiesakās';
_fc_props.no_configuration_errors = 'Nav konfigurācijas kļūdu';
_fc_props.configuration_error_summary = 'Konfigurācijas kopsavilkums';
_fc_props.configuration_errors = 'Konfigurācija';
_fc_props.question_setup = 'Jautājuma iestatīšana';
_fc_props.plant_no_default = 'Nav noklusējuma rūpnīcas';
_fc_props.plant_assign_default = 'Iestatīt noklusējuma augu';
_fc_props.master_data_error_logs = 'Galveno datu kļūdu žurnāli';
_fc_props.master_data_error_logs_fetch_failed = 'Galveno datu kļūdu žurnālu izgūšana neizdevās.';
_fc_props.equipment_flow_meter_no_pulse = 'Iekārtai ir plūsmas mērītājs, bet nav norādīts tilpums uz impulsu';
_fc_props.equipment_flow_meter_fix_no_pulse = 'Piešķirt plūsmas mērītāja tilpumu impulsā uz iekārtas';
_fc_props.equipment_flow_meter_no_unit = 'Iekārtai ir plūsmas mērītājs, bet nav izvēlēta ūdens iekārta';
_fc_props.equipment_flow_meter_fix_no_unit = 'Piešķiriet ūdens mērvienību plūsmas mērītājam uz iekārtas';
_fc_props.warn = 'Brīdināt';
_fc_props.security = 'Drošība';
_fc_props.error_validating_master_data_entity_not_found = 'Kļūda pamatdatu validācijā, vienība nav atrasta';
_fc_props.device_message_queue_not_assigned = 'device_message_queue_id vai device_message_canary_queue_id nav piešķirts database_server resursdatora nosaukumam.';
_fc_props.device_message_queue_not_assigned_resolution = 'Datubāzes_serverī ir nepieciešams derīgs device_message_queue_id un device_message_canary_queue_id.';
_fc_props.talk_queue_not_assigned = 'talk_queue_id vai talk_canary_queue_id nav piešķirts database_server resursdatora nosaukumam';
_fc_props.talk_queue_not_assigned_resolution = 'Datubāzes_serverī nepieciešams derīgs talk_queue_id un talk_canary_queue_id.';
_fc_props.device_message_queue_dne = 'device_message_queue_id nepastāv datu bāzes_servera_id.';
_fc_props.device_message_queue_dne_resolution = 'Nepieciešams derīgs device_message_queue_id tabulai database_server.';
_fc_props.device_message_canary_queue_dne = 'device_message_canary_queue_id nepastāv datu bāzes_servera_id.';
_fc_props.device_message_canary_queue_dne_resolution = 'Nepieciešams derīgs device_message_canary_queue_id tabulai database_server.';
_fc_props.talk_queue_id_dne = 'talk_queue_id nepastāv datu bāzes_servera_id.';
_fc_props.talk_queue_id_dne_resolution = 'Nepieciešams derīgs talk_queue_id tabulai database_server';
_fc_props.talk_canary_queue_id_dne = 'talk_canary_queue_id nepastāv datu bāzes_servera_id.';
_fc_props.talk_canary_queue_id_dne_resolution = 'Nepieciešams derīgs talk_canary_queue_id tabulai database_server';
_fc_props.device_message_queue_no_default = 'device_message_queue trūkst noklusējuma vērtības';
_fc_props.device_message_queue_no_default_resolution = 'Piešķirt noklusējuma vērtību device_message_queue rindā';
_fc_props.message_queue_url_dne = 'message_queue_url ir nulle device_message_queue rindā';
_fc_props.message_queue_url_dne_resolution = 'Nepieciešams derīgs message_queue_url device_message_queue rindā';
_fc_props.talk_queue_url_dne = 'talk_queue_url ir nulle device_message_queue rindā';
_fc_props.talk_queue_url_dne_resolution = 'Nepieciešams derīgs talk_queue_url device_message_queue rindā';
_fc_props.database_server_id_dne = 'Uzņēmumam nepastāv datu bāzes_servera_id';
_fc_props.database_server_id_dne_resolution = 'Tabulā database_server ir nepieciešams derīgs database_server_id.';
_fc_props.dbname_assigned_dne = 'Lietotājiem piešķirts datubāzes nosaukums, bet uzņēmums nepastāv';
_fc_props.dbname_assigned_dne_resolution = 'Noņemt no ierakstiem no lietotāja_db, kur dbname neeksistē';
_fc_props.canary_totals = 'Kanāriju salu kopsummas';
_fc_props.failed_to_find_trackit_environment = 'Neizdevās atrast TrackItEnvironment';
_fc_props.failed_to_find_trackit_environment_resolution = 'Visticamāk, resursdatora nosaukums nav kartēts pakalpojumā TrackItEnvironment.';
_fc_props.quartz_jobs_not_scheduled = 'Trūkstošie kvarca darbi';
_fc_props.quartz_jobs_not_scheduled_resolution = 'Ieplānojiet trūkstošos darbus';
_fc_props.database_dne_for_company = 'Uzņēmuma datubāze neeksistē';
_fc_props.database_dne_for_company_resolution = 'Noņemt uzņēmumu no uzņēmumu tabulas, kā arī no user_db tabulas';
_fc_props.deliveries_not_using_cloud_auth = 'Piegādes neizmanto mākoņa autentifikāciju';
_fc_props.deliveries_not_using_cloud_auth_resolution = 'Iespējot mākoņa autentifikāciju piegādēm biļešu integrācijas iestatījumos';
_fc_props.talk_using_quartz_scheduler = 'Saruna izmanto Quartz plānotāju';
_fc_props.talk_using_quartz_scheduler_resolution = 'Vietnes iestatījumos iespējojiet AWS izmantošanu sarunām';
_fc_props.data_migration_scheduled_and_shouldnt = 'Datu migrācija ir ieplānota un tai nevajadzētu notikt';
_fc_props.data_migration_scheduled_and_shouldnt_resolution = 'Atspējot datu migrācijas kvarca uzdevumu';
_fc_props.data_migration_not_scheduled = 'Datu migrācija nav ieplānota un tai vajadzētu būt';
_fc_props.data_migration_not_scheduled_resolution = 'Iespējot datu migrācijas kvarca uzdevumu';
_fc_props.data_migration_not_allowed = 'Datu migrācija nav atļauta ierīcē';
_fc_props.data_migration_allowed_on = 'Datu migrācija ir atļauta';
_fc_props.enable_data_migration = 'Iespējot datu migrāciju katram uzņēmumam';
_fc_props.disable_data_migration = 'Atspējot datu migrāciju katram uzņēmumam';
_fc_props.delayed_jobs_resolution = 'Atjaunot aktivizētājus, dzēst aktivizētājus vai restartēt QuartzManager';
_fc_props.environment_setup = 'Vides kopsavilkums';
_fc_props.deprecated = 'Novecojis';
_fc_props.quartz_scheduler = 'Kvarca plānotājs';
_fc_props.device_queues = 'Ierīču rindas';
_fc_props.data_migration = 'Datu migrācija';
_fc_props.delayed_jobs = 'Kavēti darbi';
_fc_props.hide_find_truck_menu_option = 'Slēpt izvēlnes opciju “Atrast kravas automašīnu”';
_fc_props.configuration_audit_info = 'Konfigurācijas audita informācija';
_fc_props.the_master_data_is_not_enabled_yet = 'Galvenie dati vēl nav iespējoti';
_fc_props.the_master_data_enablement_audit_info = 'Lietotājs ir {0} izveidojis pamatdatus';
_fc_props.on_lower = 'ieslēgts';
_fc_props.enabled_lower = 'iespējots';
_fc_props.disabled_lower = 'invalīds';
_fc_props.mechanic_updated_successfully = 'Mehāniķis veiksmīgi atjaunināts.';
_fc_props.no_audit_record = 'Nav pieejams audita ieraksts.';
_fc_props._7_years = '7 gadi (arhīvs)';
_fc_props.retention_continue = 'Turpināt';
_fc_props.retention_save_confirm_message = 'Tas ietekmēs serverī saglabāto datu apjomu, un noņemtos datus NEVAR ATGŪT. Vai vēlaties turpināt?';
_fc_props.cloud_dvir__uom_change_confirmation_title = 'Odometra mērvienību un vērtību apstiprināšana';
_fc_props.cloud_dvir__uom_change_confirmation = 'Pašreizējā odometra vērtība ir {{engineValue}} {{engineUom}}, un ievadītais odometra rādījums ir {{fromValue}} {{fromUom}}. Vai tas ir pareizi?';

export default _fc_props;
